<template>
    <div class="container-center invite-mng-info">


        <!-- 顶部标题 -->
        <div class="inviteInfo solid">
            <div class="option-btn-group">
                <el-button class="btn-nego" @click="$router.push('/inviteNego/'+ encodeURIComponent(fid) +'/'+ encodeURIComponent(infoData.fname))">
                    <span>{{ negoNum }}</span>洽谈通知
                </el-button>
                <el-button type="" @click="managersDialogShow = true">项目经理</el-button>
                <el-button class="btn-unpaid" @click="showUnpaidDialog" v-if="(stepStatus >= 1 && stepStatus <= 8) && buttonFlag">弃标
                </el-button>
            </div>
            <p :class="[infoData.finvitemethod.charAt(0) === '3' ? 'strategy' : '', 'title']">{{infoData.fname}}</p>
            <p>发布时间：{{ infoData.fdistributedate }}</p>
        </div>

        <!-- 状态步骤 - 项目 -->
        <div v-if="stepStatus==1 || reviewStatus==1" class="invite-top-step">
            <el-steps :active="stepStatus" align-center>
                <template v-if='!isStrategy'>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(1)">报名</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(1)">1</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(2)">入围通知</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(2)">2</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(3)">发标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3)">3</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(3)">标书下载</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3)">4</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(5)">踏勘及答疑</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(5)">5</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(6)">回标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(6)">6</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(7)">询标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(7)">7</span>
                    </el-step>
                    <el-step v-if="infoData.threeSelfType != '1' && infoData.isSimple != '2'">
                        <span slot="title" @click="gotoTabVie(8)">竞价</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(8)">8</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(9)">定标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(9)">9</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(10)">签约</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(10)">10</span>
                    </el-step>
                </template>

                <template v-else>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(1)">报名</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(1)">1</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(2)">入围通知</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(2)">2</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(3)">发标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3)">3</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(3)">标书下载</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3)">4</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(5)">踏勘及答疑</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(5)">5</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(6)">回标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(6)">6</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(7)">询标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(7)">7</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(9)">定标</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(9)">9</span>
                    </el-step>
                    <el-step>
                        <span slot="title" @click="gotoTabVie(10)">签约</span>
                        <span slot="icon" class="slot_step_icon" @click="gotoTabVie(10)">10</span>
                    </el-step>
                </template>

            </el-steps>
        </div>


        <!-- 状态 1 报名 -->
        <div v-if="stepStatus==1 || reviewStatus==1">

            <div class="inviteInfo dashed">
                <h5>招标信息</h5>
                <el-row>
                    <el-col :span="3">招标项概况：</el-col>
                    <el-col :span="21">
                        <div v-for="item in finvitecontentArr">{{item}}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">入围资质、资质要求：</el-col>
                    <el-col :span="21">
                        <div v-for="item in fqulificademandArr">{{item}}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">报名须知：</el-col>
                    <el-col :span="21">
                        <div v-for="item in signNoticeArr">{{ item }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">投标保证金说明：</el-col>
                    <el-col :span="21">
                        <div v-for="item in cashDepositDesArr">{{ item }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">特别提示：</el-col>
                    <el-col :span="21">
                        <div v-for="item in hotTipArr">{{ item }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">报名开始时间：</el-col>
                    <el-col :span="21">{{ infoData.cfinvregisteddeadlinest }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">报名截止时间：</el-col>
                    <el-col :span="21">{{ infoData.finvregisteddeadline }}</el-col>
                </el-row>
            </div>

            <div class="inviteInfo" v-if="!isStrategy">
                <h5>标段信息</h5>
                <div v-for="o in infoData.segmentList" class="inviteInfo dashed segment" :key="o.id">
                    <el-row>
                        <el-col :span="3">标段：</el-col>
                        <el-col :span="5">{{ o.fcurprojectname +'-'+ o.fbidnum }}
                            <el-tag v-if="o.hasSign" type="warning" size="mini">已报名</el-tag>
                        </el-col>
                        <el-col :span="3">所属项目：</el-col>
                        <el-col :span="5">{{ o.fcurprojectname }}</el-col>
                        <el-col :span="3">产品及服务：</el-col>
                        <el-col :span="5">
                            <span v-for="(oo,index) in o.productTypeList" :key="oo.id"><span v-if="index > 0">、</span>{{ oo.fnameL2 }}</span>
                        </el-col>
                    </el-row>
                    <el-row v-if="o.hasSign">
                        <el-col :span="3">报名联系人：</el-col>
                        <el-col :span="5">{{ infoData.linkpersonList[0] ? infoData.linkpersonList[0].fpersonname :
                            '#缺省#' }}
                        </el-col>
                        <el-col :span="3">联系人电话：</el-col>
                        <el-col :span="5">{{ infoData.linkpersonList[0] ? infoData.linkpersonList[0].fphone : '#缺省#'
                            }}
                        </el-col>
                    </el-row>
                </div>
            </div>

        </div>


        <!-- 分标段进度状态信息 -->
        <el-tabs v-if="(reviewStatus!=0 ? reviewStatus!=1 : stepStatus!=1)" v-model="segmentActive" type="border-card"
                 @tab-click="tabClick" class="tabs-margin canStrategy">

            <el-tab-pane v-for="(tab,index) in selectInfo" :name="'tab'+ index">

            <span slot="label">
                {{ tab.inviteProjectEntry && (tab.inviteProjectEntry.fcurprojectname +'-'+ tab.inviteProjectEntry.fbidnum) }}
                <el-tag type="warning" size="mini">{{ ['已报名','入围通知','发标','标书下载','踏勘及答疑','回标','询标','竞价','定标','签约'][tab.bidStatus] }}</el-tag>
            </span>


                <!-- 状态步骤 - 标段 -->
                <div v-if="reviewStatus==0" class="invite-top-step">
                    <el-steps :active="+tab.bidStatus +1" align-center>
                        <template v-if='!isStrategy'>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(1, tab.bidStatus)">报名</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(1, tab.bidStatus)">1</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(2, tab.bidStatus)">入围通知</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(2, tab.bidStatus)">2</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(3, tab.bidStatus)">发标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3, tab.bidStatus)">3</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(3, tab.bidStatus)">标书下载</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3, tab.bidStatus)">4</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(5, tab.bidStatus)">踏勘及答疑</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(5, tab.bidStatus)">5</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(6, tab.bidStatus)">回标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(6, tab.bidStatus)">6</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(7, tab.bidStatus)">询标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(7, tab.bidStatus)">7</span>
                            </el-step>
                            <el-step v-if="infoData.threeSelfType != '1' && infoData.isSimple != '2'">
                                <span slot="title" @click="gotoTabVie(8, tab.bidStatus)">竞价</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(8, tab.bidStatus)">8</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(9, tab.bidStatus)">定标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(9, tab.bidStatus)">9</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(10, tab.bidStatus)">签约</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(10, tab.bidStatus)">10</span>
                            </el-step>
                        </template>
                        <template v-else>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(1, tab.bidStatus)">报名</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(1, tab.bidStatus)">1</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(2, tab.bidStatus)">入围通知</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(2, tab.bidStatus)">2</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(3, tab.bidStatus)">发标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3, tab.bidStatus)">3</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(3, tab.bidStatus)">标书下载</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(3, tab.bidStatus)">4</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(5, tab.bidStatus)">踏勘及答疑</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(5, tab.bidStatus)">5</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(6, tab.bidStatus)">回标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(6, tab.bidStatus)">6</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(7, tab.bidStatus)">询标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(7, tab.bidStatus)">7</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(9, tab.bidStatus)">定标</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(9, tab.bidStatus)">9</span>
                            </el-step>
                            <el-step>
                                <span slot="title" @click="gotoTabVie(10, tab.bidStatus)">签约</span>
                                <span slot="icon" class="slot_step_icon" @click="gotoTabVie(10, tab.bidStatus)">10</span>
                            </el-step>
                        </template>
                    </el-steps>
                </div>


                <!-- 状态 2 入围 -->
                <div v-if="reviewStatus!=0 ? reviewStatus==2 : tab.bidStatus==1">
                    <h4>投标保证金</h4>
                    <div class="select-info">
                        <p>请将投标保证金汇款至以下账户：</p>
                        <el-row>
                            <el-col :span="2">公司抬头：</el-col>
                            <el-col :span="5">{{ tab.companyNo }}</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">开户行：</el-col>
                            <el-col :span="5">{{ tab.bankName }}</el-col>
                            <el-col :span="2">银行卡号：</el-col>
                            <el-col :span="5">{{ tab.bankNo }}</el-col>
                        </el-row>
                        <p>相关问题，您可联系以下人员：</p>
                        <el-row>
                            <el-col :span="2">联系人：</el-col>
                            <el-col :span="5">{{ tab.financePerson }}</el-col>
                            <el-col :span="2">联系电话：</el-col>
                            <el-col :span="5">{{ tab.personTel }}</el-col>
                        </el-row>
                        <p>注意：请在 <b>{{ tab.paymentEndDate || '#缺省#' }}</b> 之前缴纳，否则无法下载标书。</p>
                    </div>
                </div><!-- 状态 2 入围 -->


                <!-- 状态 4 标书下载 -->
                <div v-if="(reviewStatus!=0 ? reviewStatus==3 : (stepStatus==3||stepStatus==4))" class="box-bordered">
                    <h4>标书下载</h4>
                    <div v-if="tenderList.length == 0" class="no-data-tip"></div>
                    <ul v-else @click="updateStatus" class="invite-mng-list">
                        <li v-for="li in tenderList" :key="li.id">
                            <a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{
                                li.fileOldName }}</a>
                            <!--<a v-else href="javascript:;"
                               @click="$alert('您还没有提交保证金，无法下载标书。', '提示', {confirmButtonText: '确定'})">{{ li.fileOldName
                                }}</a>  v-if="tenderCanDown"-->
                        </li>
                    </ul>
                </div>


                <!-- 状态 5 踏勘及答疑 -->
                <invite-recon :data="$data" :tab="tab" :showReconReply="showReconReply"
                              :showReconQstList="showReconQstList"></invite-recon>


                <!-- 状态 6 回标 -->
                <div
                    v-if="(reviewStatus!=0 ? false : ((isAnswerEnd && tab.bidStatus<6)  ||  tab.bidStatus==4 || tab.bidStatus==5 ) && tab.isDownload==1)"
                    style="margin-top:20px;" class="bid-wrap">
                    <div>
                        <div v-if="bidCould">
                            <el-button :disabled="!buttonFlag" type="primary" size="mini" v-if='bidBusBtnIsGrey' class='el-button-grey'><b>+</b> 商务标回标</el-button>
                            <el-button :disabled="!buttonFlag" type="primary" size="mini" @click="addBidBusiShow" v-else><b>+</b>商务标回标</el-button>
                            <div v-if="(infoData.threeSelfType != '1' && infoData.threeSelfType != '2') || ((infoData.threeSelfType == '1' || infoData.threeSelfType == '2') && businessScore == '2')" style="display: inline;">
                                <el-button :disabled="!buttonFlag" type="primary" size="mini" v-if="bidTechBtnIsGrey" class='el-button-grey'><b>+</b> 技术标回标</el-button>
                                <el-button :disabled="!buttonFlag" type="primary" size="mini" @click="addBidTechShow" v-else><b>+</b>技术标回标</el-button>
                            </div>
                        </div>
                        <div v-else>
                            <el-alert title="" type="error" :closable="false">您尚未提交保证金，无法进行回标。</el-alert>
                        </div>
                    </div>
                    <div v-if="reviewStatus<7" class="title">回标截止时间：{{infoData.fprtenderdate}}</div>
                </div>

                <div v-if="reviewStatus!=0 ? reviewStatus==6 : tab.bidStatus==5">
                    <div class="tech-fail-div" v-if="!!techFailReson">
                        <h4>技术标不合格</h4>
                        <div>
                            <label class="fail-label">原因：</label>
                            <span>{{ techFailReson }}</span>
                        </div>
                    </div>

                    <el-tabs v-model="bidTabActive" type="card" @tab-click="" class="tabs-margin U">

                        <el-tab-pane :name="'tab01'">
                            <span slot="label">商务标回标</span>
                            <div v-if="bidBusiList.length == 0" class="no-data-tip"></div>
                            <ul v-else class="invite-mng-list">
                                <li v-for="(li,index) in bidBusiList">
                                    <a @click="(li.isDraft==1)?draftBidBusi(li):showBidBusiList(li.id)"
                                       href="javascript:;">{{ infoData.fname }} 商务标</a>
                                    <el-tag v-if="li.isDraft==1" type="warning" size="mini">草稿</el-tag>
                                    <span v-if="index!=0"
                                          style="float:right;color: red;margin-left: 20px;cursor:pointer"
                                          @click="deleteHb(li.id,'sw')">删除</span>
                                    <span style="float: right;">{{ li.createDate }}</span>
                                </li>
                            </ul>
                        </el-tab-pane>

                        <el-tab-pane :name="'tab02'" v-if="(infoData.threeSelfType != '1' && infoData.threeSelfType != '2') || ((infoData.threeSelfType == '1' || infoData.threeSelfType == '2') && businessScore == '2')">
                            <span slot="label">技术标回标</span>
                            <div v-if="bidTechList.length == 0" class="no-data-tip"></div>
                            <ul v-else class="invite-mng-list">
                                <li v-for="(li,index) in bidTechList"><a @click="showBidTechList(li.id)"
                                                                         href="javascript:;">{{ infoData.fname }}
                                    技术标</a><span v-if="index!=0"
                                                 style="float:right;color: red;margin-left: 20px;cursor:pointer"
                                                 @click="deleteHb(li.id,'js')">删除</span><span style="float: right;">{{ li.createDate }}</span>
                                </li>
                            </ul>
                        </el-tab-pane>

                    </el-tabs>



                </div><!-- 状态 6 回标 -->


                <!-- 状态 7 询标 -->
                <el-tabs v-if="(reviewStatus!=0 ? reviewStatus==7 : tab.bidStatus==6)" v-model="inqTabActive"
                         type="card" class="tabs-margin U">
                    <el-tab-pane :name="'tab01'">
                        <span slot="label">商务标</span>
                        <div v-if="inqBidBusiList.length == 0" class="no-data-tip"></div>
                        <ul v-else class="invite-mng-list">
                            <li v-for="li in inqBidBusiList">
                                <router-link
                                    :to="{name:'InviteBid',params:{ fid:li.fid, pid:li.inviteProjectId, type:0 ,urlFid:urlFid, buttonFlag:buttonFlag}}">
                                    {{ li.inquiryTital || '#缺省#' }}
                                </router-link>
                                <span style="float:right;">{{ li.inquiryDate }}</span></li>
                        </ul>
                    </el-tab-pane>

                    <el-tab-pane :name="'tab02'" v-if="(infoData.threeSelfType != '1' && infoData.threeSelfType != '2') || ((infoData.threeSelfType == '1' || infoData.threeSelfType == '2') && businessScore == '2')">
                        <span slot="label">技术标</span>
                        <div v-if="inqBidTechList.length == 0" class="no-data-tip"></div>
                        <ul v-else class="invite-mng-list">
                            <li v-for="li in inqBidTechList">
                                <router-link
                                    :to="{name:'InviteBid',params:{ fid:li.fid, pid:li.inviteProjectId, type:1, buttonFlag:buttonFlag }}">
                                    {{ li.inquiryTital || '#缺省#' }}
                                </router-link>
                                <span style="float:right;">{{ li.inquiryDate }}</span>
                            </li>
                        </ul>
                    </el-tab-pane>

                    <el-tab-pane :name="'tab03'" v-if="(infoData.threeSelfType != '1' && infoData.threeSelfType != '2') || ((infoData.threeSelfType == '1' || infoData.threeSelfType == '2') && businessScore == '2')">
                        <span slot="label">投标封样</span>
                        <div v-if="inqBidDemoList.length == 0" class="no-data-tip"></div>
                        <ul v-else class="invite-mng-list">
                            <li v-for="li in inqBidDemoList">
                                <router-link
                                    :to="{name:'InviteBid',params:{ fid:li.fid, pid:li.inviteProjectId, type:2, buttonFlag:buttonFlag }}">
                                    {{ li.inquiryTital || '#缺省#' }}
                                </router-link>
                                <span style="float:right;">{{ li.inquiryDate }}</span>
                            </li>
                        </ul>
                    </el-tab-pane>

                </el-tabs>

                <!-- 状态 8 竞价 -->
                <div v-if="((reviewStatus!=0 ? reviewStatus==8 : tab.bidStatus==7)&&!isStrategy && ((infoData.threeSelfType != '1' && infoData.threeSelfType != '2') || ((infoData.threeSelfType == '1' || infoData.threeSelfType == '2') && businessScore == '2')))" class="price-box">
                    <el-card class="price-left">
                        <ul>
                            <template v-if="isTwoPay == '0'">
                                <li v-for="li in priceData.businessPriceList">
                                    <label>{{ li.turn }} 轮报价{{newFlag?'除税价':'含税价'}}</label>
                                    <span>{{ newFlag ? li.notaxBusinessPrice : li.taxBusinessPrice }} 元</span>
                                    <i v-bind:class="(li.isBoult==2||li.isBoult==4)?'success':'fail'">{{ li.isBoult ?
                                        ['','失败','通过','放弃','成功', '竞价中', '不宣标'][li.isBoult] : '进行中' }}</i>
                                </li>
                            </template>
                            <template v-else>
                                <li v-for="(list, index) in priceData.businessPriceTwoList" style="position: relative;">
                                    <label>{{ priceData.businessPriceTwoList.length - index }} 轮报价{{newFlag?'除税价':'含税价'}}</label>
                                    <div style="position:absolute; margin-left: 28px;margin-top: 3px;" class="mutiply-result">
                                        <div v-for="li in list">
                                            <span v-if="li.payMethod == 1">付款方式一({{pay1}})</span>
                                            <span v-else>付款方式二({{pay2}})</span>
                                            <span>{{ newFlag ? li.notaxBusinessPrice : li.taxBusinessPrice }} 元</span>
                                            <i v-bind:class="(li.isBoult==2||li.isBoult==4)?'success':'fail'">{{ li.isBoult ?
                                                ['','失败','通过','放弃','成功', '竞价中', '不宣标'][li.isBoult] : '进行中' }}</i>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </el-card>
                    <el-card class="price-right">
                        <div v-if="priceResult==4 && !!showMsg" v-bind:class="['price-right-tip','result']">{{ showMsg
                            }}
                        </div>
                        <div v-if="priceResult==4 && !showMsg" v-bind:class="['price-right-tip','success']"></div>
                        <div v-if="priceResult==2" v-bind:class="['price-right-tip','pass']"></div>
                        <div v-if="priceResult==6" v-bind:class="['price-right-tip','result']">{{ showMsg }}</div>
                        <div v-if="(priceResult==1 || priceResult==3) && !!showMsg"
                             v-bind:class="['price-right-tip','result']">{{ showMsg }}
                        </div>
                        <div v-if="(priceResult==1 || priceResult==3) && !showMsg"
                             v-bind:class="['price-right-tip','fail']"></div>
                        <div v-if="!priceResult || priceResult==5">
                            <div class="price-timer">倒计时 <span>{{ priceTimer }}</span></div>
<!--                            <template v-if="isTwoPay == '1'">-->
                            <template v-if="isTwoPay == '0'">
                                <el-form label-width="90px" v-model="priceForm" ref="priceForm">
                                    <el-form-item label="除税总价：">
                                        <el-input size="medium" @blur="cachePriceForm"
                                                  v-model="priceForm.notaxBusinessPrice" placeholder="请输入除税总价(限整数)"
                                                  clearable>
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="税率：">
                                        <el-input size="medium" @blur="cachePriceForm" v-model="priceForm.tax"
                                                  placeholder="请输入税率" clearable>
                                            <template slot="append">%</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="含税总价：">
                                        <el-input size="medium" v-model="priceAll2" disabled>
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </template>
                            <template v-else>
                                <el-form label-width="90px" v-model="priceForm" ref="priceForm">
                                    <div style="margin-bottom: 10px">付款方式一（{{pay1}}）</div>
                                    <el-form-item label="除税总价：">
                                        <el-input :disabled="!payMethod1Enable" size="medium" @blur="cachePriceForm"
                                                  v-model="priceForm.notaxBusinessPrice" placeholder="请输入除税总价(限整数)"
                                                  clearable>
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="税率：">
                                        <el-input :disabled="!payMethod1Enable" size="medium" @blur="cachePriceForm" v-model="priceForm.tax"
                                                  placeholder="请输入税率" clearable>
                                            <template slot="append">%</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="含税总价：">
                                        <el-input size="medium" v-model="priceAll2" disabled>
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                    <div class="dashed">&nbsp;</div>
                                    <div style="margin-bottom: 10px">付款方式二（{{pay2}}）</div>
                                    <el-form-item label="除税总价：">
                                        <el-input :disabled="!payMethod2Enable" size="medium" @blur="cachePriceForm"
                                                  v-model="priceForm.notaxBusinessPrice1" placeholder="请输入除税总价(限整数)"
                                                  clearable>
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="税率：">
                                        <el-input :disabled="!payMethod2Enable" size="medium" @blur="cachePriceForm" v-model="priceForm.tax1"
                                                  placeholder="请输入税率" clearable>
                                            <template slot="append">%</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="含税总价：">
                                        <el-input size="medium" v-model="priceAll4" disabled>
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </template>
                            <div class="text-center">
                                <el-button v-if="priceResult==5" type="primary" disabled size="medium">已 提 交</el-button>
                                <el-button :disabled="!buttonFlag" v-else type="primary" size="medium"
                                           @click="checkPriceForm">提 交
                                </el-button>
                            </div>
                        </div>
                    </el-card>
                </div>

                <!-- 定标  履约保证状态转换 -->
                <div v-show="(reviewStatus!=0 ? reviewStatus==9 : tab.bidStatus==8) && peInviteInfo != null">

                    <div class="table-box">
                        <el-row class="table-head">
                            <el-col :span="16" class="textLeft">履约担保类型</el-col>
                        </el-row>
                        <el-row class="table-row">
                            <el-col :span="16" class="textLeft">当前投标履约类型：{{ peInviteInfo.nowTypeName }}</el-col>
                            <el-col :span="8" class="textRight">
                                <el-button type="primary" @click="openPeDialog" size="mini" >履约担保形式转换</el-button>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="table-box">
                        <el-row class="table-head">
                            <el-col :span="16" class="textLeft">履约担保变更信息</el-col>
                        </el-row>
                        <el-row class="table-row" v-for="(tempPe, peIndex) in peInviteInfo.changeTypeRecords" :key="peIndex">
                            <el-col :span="10" class="textLeft">{{ changeNameArray[tempPe.changeType] }}</el-col>
                            <el-col :span="6" :class="`textLeft status-color${tempPe.approveStatus}`">{{ auditArray[tempPe.approveStatus] }}</el-col>
                            <el-col :span="8" class="textRight">
                                <el-button type="text" size="mini" @click="openShowDialog(tempPe.id)">查看详情</el-button>
                            </el-col>
                        </el-row>
                    </div>

                    <change-pe-type-dialog ref="peDialog" @addAfter="getChangeInfo"
                                           :inviteProjectId="fid" :nowType="peInviteInfo.nowType"
                                           :entryId="tab.nviteProjectEntryId"
                                           :nodeType="1"></change-pe-type-dialog>
                </div>

                <div class="inviteInfo dashed" v-if="(reviewStatus!=0 ? true : tab.bidStatus != 0)">
                    <h5>联系信息</h5>
                    <el-row>
                        <el-col :span="3">招标负责人：</el-col>
                        <el-col :span="21">{{ infoData.fresppersonName }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">联系电话：</el-col>
                        <el-col :span="21">{{ infoData.fphone}}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">电子邮箱：</el-col>
                        <el-col :span="21">{{ infoData.femail }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">地址：</el-col>
                        <el-col :span="21">{{ infoData.faddress }}</el-col>
                    </el-row>
                    <!-- <el-row><el-col :span="3">传真：</el-col><el-col :span="21">{{ infoData.ffax }}</el-col></el-row> -->
                </div>

                <div v-if="reviewStatus==0">
                    <h4>招标进度</h4>
                    <ul class="invite-btm-step">
                        <li v-for="o in process">

                            <div v-html="o.time ? o.time.replace(' ','<br>') : ''"></div>

                            <div>
                                <span v-bind:class="[o.finishMsg == '完成' ? 'success' : 'info']">{{ o.finishMsg }}</span>
                            </div>
                            <div>
                                <b v-if="o.title=='报名信息'"><a @click="reviewStatus=1;toTop();" href="javascript:;">{{
                                    o.title }}</a></b>
                                <b v-else-if="o.title=='入围信息'"><a @click="reviewStatus=2;toTop();" href="javascript:;">{{
                                    o.title }}</a></b>
                                <b v-else-if="o.title=='下载标书'"><a @click="reviewStatus=3;toTop();" href="javascript:;">{{
                                    o.title }}</a></b>
                                <b v-else-if="o.title=='踏勘答疑'"><a @click="reviewStatus=5;toTop();" href="javascript:;">{{
                                    o.title }}</a></b>
                                <b v-else-if="o.title=='回标信息'"><a @click="reviewStatus=6;toTop();" href="javascript:;">{{
                                    o.title }}</a></b>
                                <b v-else-if="o.title=='询标信息'"><a @click="reviewStatus=7;toTop();" href="javascript:;">{{
                                    o.title }}</a></b>
                                <b v-else-if="o.title=='竞价信息'"><a @click="reviewStatus=8,getPriceInfo(),toTop();"
                                                                  href="javascript:;">{{ o.title }}</a></b>
                                <b v-else>{{ o.title }}</b>
                                <br>
                                状态：{{ o.status }}
                            </div>
                            <div style="clear:both;"></div>
                        </li>
                    </ul>
                </div>


            </el-tab-pane>

        </el-tabs>


        <el-dialog title="项目经理" :visible.sync="managersDialogShow" width="1200px" center :before-close='closeManagersDialog'>
            <div v-if='emptyManagers' style="color: red;text-align: center;">为了不影响您的招投标业务，烦请选择好投标的项目经理</div>
            <el-tabs v-model="managersActive" type="border-card" @tab-click="" class="tabs-margin canStrategy">
                <div v-if="managersSegList.length==0 && !isStrategy" class="no-data-tip"></div>
                <el-tab-pane v-else v-for="(tab,index) in managersSegList" :name="'tab'+ index" :key="index">
                    <span slot="label">{{ tab.fcurprojectname + (tab.fbidnum?'-':'') + tab.fbidnum }} </span>
                    <el-table :data="managersSegList[index].managers" border stripe size="mini">
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column prop="idCard" label="身份证"></el-table-column>
                        <el-table-column prop="mobile" label="手机"></el-table-column>
                        <el-table-column prop="officeTel" label="办公电话"></el-table-column>
                        <el-table-column prop="email" label="邮箱"></el-table-column>
                        <el-table-column prop="major" label="专业"></el-table-column>
                        <el-table-column prop="grade" label="建造师级别"></el-table-column>
                        <el-table-column prop="certificateNo" label="证书编号"></el-table-column>
                        <el-table-column prop="achievement" label="业绩"></el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == '0' || scope.row.status == null">未认证</span>
                                <span v-if="scope.row.status == '1'">已认证</span>
                                <span v-if="scope.row.status == '2'">已离职</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="achievement" label="操作" v-if="stepStatus<=7">
                            <template slot-scope="scope">
                                <el-button :disabled="!buttonFlag"
                                           @click="opMgr(tab.fid, scope.row.id);managersForm.set=true" type="text"
                                           size="small">更换
                                </el-button>
                                <el-button :disabled="!buttonFlag" @click="delMgr(tab.fid, scope.row.id)" type="text"
                                           size="small">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <br>
                    <el-button :disabled="!buttonFlag" @click="opMgr(tab.fid);managersForm.add=true" v-if="stepStatus<=6 && !bidDateEnd" type="primary" size="mini">添加项目经理
                    </el-button>
                </el-tab-pane>

            </el-tabs>

        </el-dialog>

        <el-dialog title="选择项目经理" :visible.sync="managersFulDialogShow" width="640px" @close="resetForm" center>

            <div class="invite-dialog-form">

                <p>可选的项目经理：</p>
                <div v-if="managersFulList.length==0" class="no-data-tip"></div>
                <div v-else>
                    <div v-if="managersForm.add==true">
                        <el-checkbox v-for="o in managersFulList" :key="o.id" v-model="managersForm.managers"
                                     :label="o.id">{{ o.name }}：{{ o.mobile }}
                        </el-checkbox>
                    </div>
                    <div v-else>
                        <el-radio v-for="o in managersFulList" :key="o.id" v-model="managersForm.manager" :label="o.id">
                            {{ o.name }}：{{ o.mobile }}
                        </el-radio>
                    </div>
                </div>

            </div>

            <span slot="footer" class="dialog-footer">
            <el-button @click="managersFulDialogShow = false">取 消</el-button>
            <el-button v-if="managersForm.set" type="primary" @click="setMgr">更 换</el-button>
            <el-button v-if="managersForm.add" type="primary" @click="addMgr">添 加</el-button>
        </span>

        </el-dialog>


        <el-dialog title="新增提疑" :visible.sync="reconQstDialogShow" width="640px" @close="resetForm" center>

            <el-form class="invite-form" label-width="140px" ref="reconQstForm" :model="reconQstForm">

                <el-form-item label="提疑类型：" prop="">
                    <el-radio v-model="reconQstForm.questionType" label="0">标书提疑</el-radio>
                    <el-radio v-model="reconQstForm.questionType" label="1">踏勘提疑</el-radio>
                    <el-radio v-model="reconQstForm.questionType" label="2">无疑问</el-radio>
                </el-form-item>

                <div v-if="reconQstForm.questionType!=2">
                    <el-form-item label="提疑标题：" prop="">
                        <el-input size="medium" v-model="reconQstForm.askTitle" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="内容：" prop="">
                        <el-input v-model="reconQstForm.askContent" type="textarea" :rows="3" placeholder="请输入内容">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="附件：" prop="">
                        <el-upload
                            class="upload-demo"
                            :before-upload="beforeUpload"
                            :on-remove="handleRemoveReconQst"
                            :action="uploadApi"
                            :on-success="addReconQstHandle"
                            :on-error="uploadError"
                            multiple
                            :limit="20"
                            :file-list="reconQstForm.baseFileList">
                            <el-button size="small" type="primary">上 传</el-button>
                            <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                        </el-upload>
                    </el-form-item>
                </div>


            </el-form>

            <span slot="footer" class="dialog-footer">
            <el-button @click="reconQstDialogShow = false">取 消</el-button>
            <el-button type="primary" :disabled="!buttonFlag" @click="addReconQst">提 交</el-button>
        </span>

        </el-dialog>

        <el-dialog title="新增现场踏勘表" :visible.sync="reconTableDialogShow" width="640px" @close="resetForm" center>


            附件：<a :href="utilBaseUrl +'pc/static/RecordSheet.docx'" target="_blank" class="reconTemplate">模版下载</a>

            <el-upload
                class="upload-demo"
                :before-upload="beforeUpload"
                :on-remove="handleRemoveReconTable"
                :action="uploadApi"
                :on-success="addReconTableHandle"
                :on-error="uploadError"
                multiple
                :limit="20"
                :file-list="reconTableForm.baseFileList">
                <el-button size="small" type="primary">上 传</el-button>
                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
            </el-upload>

            <el-checkbox style="margin-top:20px;" v-model="reconTableCheck">确认已将签章完成的踏勘表上传</el-checkbox>

            <span slot="footer" class="dialog-footer">
            <el-button @click="reconTableDialogShow = false">取 消</el-button>
            <el-button type="primary" :disabled="!buttonFlag" @click="addReconTable">提 交</el-button>
        </span>

        </el-dialog>

        <el-dialog title="我的提疑" :visible.sync="reconQstDataDialogShow" width="640px" center>
            <el-row>
                <el-col :span="4" class="text-right">提疑标题：</el-col>
                <el-col :span="20">{{ reconQstListData.askTitle }}</el-col>
                <el-col :span="4" class="text-right">提疑类型：</el-col>
                <el-col :span="20">{{ ['标书','踏勘'][reconQstListData.questionType] }}提疑</el-col>
                <el-col :span="4" class="text-right">提疑内容：</el-col>
                <el-col :span="20">{{ reconQstListData.askContent }}</el-col>
                <el-col :span="4" class="text-right">提疑附件：</el-col>
                <el-col :span="20">
                    <div v-if="reconQstListData.baseFileList.length==0" class="no-data-tip"></div>
                    <ul v-else>
                        <li v-for="li in reconQstListData.baseFileList" :key="index"><a
                            :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                    </ul>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="答疑详情" :visible.sync="reconReplyListDialogShow" width="640px" center>
            <el-row>
                <el-col :span="4" class="text-right">答疑内容：</el-col>
                <el-col :span="20">{{ reconReplyListCurr.answerContent }}</el-col>
            </el-row>
            <el-row>
                <el-col :span="4" class="text-right">答疑附件：</el-col>
                <el-col :span="20">
                    <div v-if="reconReplyListCurr.baseFileList.length==0" class="no-data-tip"></div>
                    <ul v-else>
                        <li v-for="li in reconReplyListCurr.baseFileList" :key="li.id"><a
                            :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                    </ul>
                </el-col>
            </el-row>
        </el-dialog>


        <!-- 状态 6 弹框 回标 -->
        <el-dialog :title="inviteCompanyName +'商务回标'+ new Date().getDatetime().substring(0,10).replace(/-/g,'')"
                   :visible.sync="bidBusiDialogShow" fullscreen @close="resetForm();" center>

            <iframe v-if="iframeUrl && (isDraft ? draftId : busiUUID)" style="width:100%;height:900px;border:1px solid #ccc;" name="iframeA" id="iframeA"
                    :src="iframeUrl
                    +'&listid='+ encodeURIComponent(encodeURIComponent(fid))
                    +'&periodid='+ encodeURIComponent(encodeURIComponent(selectInfo[tabIndex]?selectInfo[tabIndex].nviteProjectEntryId:''))
                    +'&creator='+ encodeURIComponent(encodeURIComponent(supplierId))
                    +'&typeid='+ (isDraft ? draftId : busiUUID)
                    +'&oldtypeid='+(oldtypeid)"
            ></iframe>

            <iframe v-else style="width:100%;height:900px;border:1px solid #ccc;" name="iframeA" id="iframeA"
                    :src="'http://10.192.1.6:8082/WebReport/ReportServer?reportlet=ListDahua.cpt&op=write'
                    +'&listid='+ encodeURIComponent(encodeURIComponent(fid))
                    +'&periodid='+ encodeURIComponent(encodeURIComponent(selectInfo[tabIndex]?selectInfo[tabIndex].nviteProjectEntryId:''))
                    +'&creator='+ encodeURIComponent(encodeURIComponent(supplierId))
                    +'&typeid='+ (isDraft ? draftId : busiUUID)
                    +'&oldtypeid='+(oldtypeid)"
            ></iframe>
            <el-form class="invite-form" label-width="140px" ref="bidBusiForm" :model="bidBusiForm" :rules="rules">

                <el-row>

                    <el-col :span="12">
                        <el-form-item label="总工期：" prop="totalDays">
                            <el-input size="medium" v-model.number="bidBusiForm.totalDays" clearable>
                                <template slot="append">天</template>
                            </el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="履约担保类型：" class="pe_change_type" prop="changeType">
                            <el-radio-group v-model="bidBusiForm.changeType">
                                <el-radio label="4">履约保证金：投标保证金转为履约保证金，差额另补</el-radio>
                                <el-radio label="5">履约保证金：另全额缴纳履约保证金</el-radio>
                                <el-radio label="6">履约保函</el-radio>
                                <el-radio label="1000">无（如无需履约担保，请选此项）</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="商务标附件：" prop="">
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveBidBusi"
                        :action="uploadApi"
                        :on-success="addBidBusiHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="20"
                        :file-list="bidBusiForm.baseFileList">
                        <el-button size="small" type="primary">商务标上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <div style="width:480px;margin:12px auto;"><el-alert title="请确保已填写并保存上方的数据到最后一步，再进行下列操作！" type="warning"
                                                                     :closable="false" show-icon></el-alert></div>
                <el-button type="primary" @click="addBidBusi(1)">保存草稿</el-button>
                <el-button v-if="!(bidTechList.length == 0 ) " type="primary" @click="addBidBusi()">提 交</el-button>
                <el-button @click="bidBusiDialogShow = false">取 消</el-button>
            </span>

        </el-dialog>


        <el-dialog title="新增商务标回标" :visible.sync="bidBusiDialogShow2" width="640px" @close="resetForm" center>

            <el-form class="invite-form" label-width="140px" ref="bidBusiForm2" :model="bidBusiForm" :rules="rules">

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="不含税报价：" prop="noTax">
                            <el-input size="medium" v-model.number="bidBusiForm.noTax" clearable>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税率：" prop="taxRate">
                            <el-input size="medium" v-model.number="bidBusiForm.taxRate" :maxlength="6" clearable>
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="总报价：" prop="">
                            <el-input size="medium" v-model="priceAll" disabled>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="总工期：" prop="totalDays">
                            <el-input size="medium" v-model.number="bidBusiForm.totalDays" clearable>
                                <template slot="append">天</template>
                            </el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-form-item label="总报价大写：" prop="">
                    <el-input size="medium" v-model="priceAllCaps" disabled></el-input>
                </el-form-item>
                <el-form-item label="报价说明：" prop="">
                    <el-input v-model="bidBusiForm.priceRemark" type="textarea" :maxlength="120" :rows="3"
                              placeholder="请输入内容">
                    </el-input>
                </el-form-item>

                <el-form-item label="履约担保类型：" class="pe_change_type" prop="changeType">
                    <el-radio-group v-model="bidBusiForm.changeType">
                        <el-radio label="4">履约保证金：投标保证金转为履约保证金，差额另补</el-radio>
                        <el-radio label="5">履约保证金：另全额缴纳履约保证金</el-radio>
                        <el-radio label="6">履约保函</el-radio>
                        <el-radio label="1000">无（如无需履约担保，请选此项）</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="商务标附件：" prop="">
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveBidBusi"
                        :action="uploadApi"
                        :on-success="addBidBusiHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="20"
                        :file-list="bidBusiForm.baseFileList">
                        <el-button size="small" type="primary">商务标上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addBidBusi">提 交</el-button>
            <el-button @click="bidBusiDialogShow2 = false">取 消</el-button>
        </span>

        </el-dialog>

        <!--  三材类招标回标数据 -->
        <el-dialog title="新增商务标回标" :visible.sync="threeReturnShow" width="700px" @close="resetForm" center>
            <div style="border: 1px solid #e4e4e4; padding-left: 3px; margin-bottom: 25px;">
                <h4 style="margin-block-start: 0.2em; margin-block-end: 0.2em;">内网信息</h4>
                <el-row>
                    <el-col :span="5" class="text-right">除税信息价：</el-col>
                    <el-col :span="7">{{infoData.noTaxInfoPrice + " " + infoData.infoPriceUnit}} </el-col>
                    <el-col :span="5" class="text-right">工程量：</el-col>
                    <el-col :span="7"> {{infoData.quantities + " " + infoData.quantitiesUnit}} </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">信息价时间：</el-col>
                    <el-col :span="19"> {{infoData.infoPriceDate}} </el-col>
                </el-row>
            </div>
            <el-form class="invite-form" label-width="140px" ref="threeForm" :model="bidBusiForm">
                <div v-for="(threeOne, i) in bidBusiForm.returnEntryList" :key="i">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="付款比例：" :prop="'returnEntryList.' + i + '.payRate'" :rules="rulesThree.payRate">
                                <el-input size="medium" v-model.number="threeOne.payRate" clearable>
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="除税竞标浮动率：" :prop="'returnEntryList.' + i + '.priceFloatRate'" :rules="rulesThree.priceFloatRate">
                                <el-input size="medium" v-model.number="threeOne.priceFloatRate" :maxlength="6" clearable>
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="报价税率：" :prop="'returnEntryList.' + i + '.taxRate'" :rules="rulesThree.taxRate">
                                <el-input size="medium" v-model.number="threeOne.taxRate" :maxlength="6" clearable>
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="除税报价总额：" :prop="'returnEntryList.' + i + '.noTax'" :rules="rulesThree.noTax">
                                <el-input size="medium" v-model="threeOne.noTax">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <el-form-item>
                    <el-button type="primary" v-if="bidBusiForm.returnEntryList.length < 2" @click="addOrEditEntry(1)">添加付款比例</el-button>
                    <el-button  v-if="bidBusiForm.returnEntryList.length > 1" @click="addOrEditEntry(2)">删除</el-button>
                </el-form-item>

                <el-form-item label="报价说明：" prop="">
                    <el-input v-model="bidBusiForm.priceRemark" type="textarea" :maxlength="120" :rows="3"
                              placeholder="请输入内容">
                    </el-input>
                </el-form-item>

                <el-form-item label="履约担保类型：" class="pe_change_type" prop="changeType" :rules="rulesThree.noTax">
                    <el-radio-group v-model="bidBusiForm.changeType">
                        <el-radio label="4">履约保证金：投标保证金转为履约保证金，差额另补</el-radio>
                        <el-radio label="5">履约保证金：另全额缴纳履约保证金</el-radio>
                        <el-radio label="6">履约保函</el-radio>
                        <el-radio label="1000">无（如无需履约担保，请选此项）</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="商务标附件：" prop="">
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveBidBusi"
                        :action="uploadApi"
                        :on-success="addBidBusiHandle"
                        :on-error="uploadError"
                        multiple
                        :limit="20"
                        :file-list="bidBusiForm.baseFileList">
                        <el-button size="small" type="primary">商务标上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitThreeForm">提 交</el-button>
                <el-button @click="threeReturnShow = false">取 消</el-button>
            </span>
        </el-dialog>

        <!--  多付款方式      -->
        <muti-pay-dialog ref="mutiPayDialog" :newFlag="newFlag" :isInviteBid="true" :bidPayCan="true" :bidPayCan1="true" :bidPayCan2="true" :pay1="pay1" :pay2="pay2" :isStandard="isStandard" :iframeUrl="iframeUrl" @formSubmit="mutiPaySubmit"></muti-pay-dialog>

        <el-dialog title="新增技术标回标" :visible.sync="bidTechDialogShow" width="640px" @close="resetForm" center>

            技术标附件：

            <el-upload
                class="upload-demo"
                :before-upload="beforeUpload"
                :on-remove="handleRemoveBidTech"
                :action="uploadApi"
                :on-success="addBidTechHandle"
                :on-error="uploadError"
                multiple
                :limit="20"
                :file-list="bidTechForm.baseFileList">
                <el-button size="small" type="primary">技术标上传</el-button>
                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
            </el-upload>

            <span slot="footer" class="dialog-footer">
        <el-button @click="bidTechDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="addBidTech">提 交</el-button>
    </span>

        </el-dialog>

        <el-dialog title="我的商务标回标" :visible.sync="bidBusiDataDialogShow" :width="infoData.threeSelfType != '1' ? '640px' : '720px'" center>
            <el-row>
                <div v-if="infoData.threeSelfType != '1'">
                    <el-row>
                        <el-col :span="4" class="text-right">不含税报价：</el-col>
                        <el-col :span="8">{{ bidBusiData.noTax }} 元</el-col>
                        <el-col :span="4" class="text-right">税率：</el-col>
                        <el-col :span="8">{{ bidBusiData.taxRate }} %</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4" class="text-right">总报价：</el-col>
                        <el-col :span="8">{{ bidBusiData.totalPrice }} 元</el-col>
                        <el-col :span="4" class="text-right">总工期：</el-col>
                        <el-col :span="8">{{ bidBusiData.totalDays }} 天</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4" class="text-right">总报价大写：</el-col>
                        <el-col :span="20">{{ bidBusiData.totalPriceCapital }}</el-col>
                    </el-row>
                </div>
                <div v-else>
                    <div style="border: 1px solid #e4e4e4; padding-left: 3px;">
                        <h4 style="margin-block-start: 0.2em; margin-block-end: 0.2em;">内网信息</h4>
                        <el-row>
                            <el-col :span="5" class="text-right">除税信息价：</el-col>
                            <el-col :span="7">{{infoData.noTaxInfoPrice + " " + infoData.infoPriceUnit}} </el-col>
                            <el-col :span="5" class="text-right">工程量：</el-col>
                            <el-col :span="7"> {{infoData.quantities + " " + infoData.quantitiesUnit}} </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="5" class="text-right">信息价时间：</el-col>
                            <el-col :span="19"> {{infoData.infoPriceDate}} </el-col>
                        </el-row>
                    </div>
                    <div v-for="(item,i) in bidBusiData.returnEntryList" :key="i">
                        <h4 style="margin-block-start: 0.2em; margin-block-end: 0.2em;">付款信息{{ i + 1 }}</h4>
                        <el-row>
                            <el-col :span="5" class="text-right">付款比例：</el-col>
                            <el-col :span="7">{{ item.payRate }} %</el-col>
                            <el-col :span="5" class="text-right">除税竞标浮动率：</el-col>
                            <el-col :span="7">{{ item.priceFloatRate }} %</el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="5" class="text-right">报价税率：</el-col>
                            <el-col :span="7">{{ item.taxRate }} %</el-col>
                            <el-col :span="5" class="text-right">除税报价总额：</el-col>
                            <el-col :span="7">{{ item.noTax }} 元</el-col>
                        </el-row>
                    </div>
                </div>

                <el-row>
                    <el-col :span="5" class="text-right">报价说明：</el-col>
                    <el-col :span="19">{{ bidBusiData.priceRemark }}</el-col>
                </el-row>

                <!-- 履约担保类型 -->
                <el-row>
                    <el-col :span="5" class="text-right">履约担保类型：</el-col>
                    <el-col :span="19">{{ changeNameArray[bidBusiData.changeType] || '无'  }}</el-col>
                </el-row>

                <el-row v-if="isStandard">
                    <el-col :span="5" class="text-right">标准清单：</el-col>
                    <el-col :span="19">
                        <a v-if="iframeUrl" :href="
                            iframeUrl
                            +'&listid='+ encodeURIComponent(encodeURIComponent(fid))
                            +'&periodid='+ encodeURIComponent(encodeURIComponent(selectInfo[tabIndex]?selectInfo[tabIndex].nviteProjectEntryId:''))
                            +'&creator='+ encodeURIComponent(encodeURIComponent(supplierId))
                            +'&typeid='+ bidBusiData.id
                        " target="_blank">查看详情
                        </a>
                        <a v-else :href="
                            'http://10.192.1.6:8082/WebReport/ReportServer?reportlet=ListDahua_View.cpt&op=view'
                            +'&listid='+ encodeURIComponent(encodeURIComponent(fid))
                            +'&periodid='+ encodeURIComponent(encodeURIComponent(selectInfo[tabIndex]?selectInfo[tabIndex].nviteProjectEntryId:''))
                            +'&creator='+ encodeURIComponent(encodeURIComponent(supplierId))
                            +'&typeid='+ bidBusiData.id
                        " target="_blank">查看详情
                        </a>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">商务标附件：</el-col>
                    <el-col :span="19">
                        <div v-if="bidBusiData.baseFileList.length==0" class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in bidBusiData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id"
                                                                          target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>
            </el-row>
        </el-dialog>

        <el-dialog title="我的技术标回标" :visible.sync="bidTechDataDialogShow" width="640px" center>
            <el-row>
                <el-col :span="4" class="text-right">技术标附件：</el-col>
                <el-col :span="20">
                    <div v-if="bidTechData.baseFileList.length==0" class="no-data-tip"></div>
                    <ul v-else>
                        <li v-for="li in bidTechData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id"
                                                                      target="_blank">{{ li.fileOldName }}</a></li>
                    </ul>
                </el-col>
            </el-row>
        </el-dialog>


        <!-- 状态 8 竞价 -->
        <el-dialog title="金额确认" :visible.sync="priceDialogShow" width="520px" center>
<!--            <template v-if="isTwoPay == '1'">-->
            <template v-if="isTwoPay == '0'">
                <center v-if='newFlag'><b>您的除税金额为</b></center>
                <center v-else><b>您的含税金额为</b></center>

                <p v-if='newFlag' class="price-caps">{{ priceAllCaps2 }}</p>
                <p v-else class="price-caps">{{ priceAll3 }}</p>

                <center><b>税率为</b></center>

                <p class="price-caps">{{ priceForm.tax }}%</p>
            </template>
            <template v-else>
                <template v-if="payMethod1Enable">
                    <center v-if='newFlag'><b>付款方式一({{pay1}}),除税金额为</b></center>
                    <center v-else><b>付款方式一({{pay1}}),含税金额为</b></center>
                    <p v-if='newFlag' class="price-caps">{{ priceAllCaps2 }}</p>
                    <p v-else class="price-caps">{{ priceAll3 }}</p>
                </template>

                <template v-if="payMethod2Enable">
                    <center v-if='newFlag'><b>付款方式二({{pay2}}),除税金额为</b></center>
                    <center v-else><b>付款方式一({{pay2}}),含税金额为</b></center>
                    <p v-if='newFlag' class="price-caps">{{ priceAllCaps4 }}</p>
                    <p v-else class="price-caps">{{ priceAll5 }}</p>
                </template>
            </template>



            <div class="price-timer">倒计时 <span>{{ priceTimer }}</span></div>

            <span slot="footer" class="dialog-footer">
            <el-button @click="priceDialogShow = false">取 消</el-button>
            <el-button type="primary" @click="priceDialogShowComfirm = true">确 认</el-button>
        </span>

        </el-dialog>


        <el-dialog title="金额再次确认" :visible.sync="priceDialogShowComfirm" width="520px" center>
<!--            <template v-if="isTwoPay == '1'">-->
            <template v-if="isTwoPay == '0'">
                <center v-if='newFlag'><b>您的除税金额为</b></center>
                <center v-else><b>您的含税金额为</b></center>

                <p v-if='newFlag' class="price-caps">{{ priceAllCaps2 }}</p>
                <p v-else class="price-caps">{{ priceAll3 }}</p>

                <center><b>税率为</b></center>

                <p class="price-caps">{{ priceForm.tax }}%</p>
            </template>
            <template v-else>
                <template v-if="payMethod1Enable">
                    <center v-if='newFlag'><b>付款方式一({{pay1}}),除税金额为</b></center>
                    <center v-else><b>付款方式一({{pay1}}),含税金额为</b></center>
                    <p v-if='newFlag' class="price-caps">{{ priceAllCaps2 }}</p>
                    <p v-else class="price-caps">{{ priceAll3 }}</p>
                </template>

                <template v-if="payMethod2Enable">
                    <center v-if='newFlag'><b>付款方式二({{pay2}}),除税金额为</b></center>
                    <center v-else><b>付款方式一({{pay2}}),含税金额为</b></center>
                    <p v-if='newFlag' class="price-caps">{{ priceAllCaps4 }}</p>
                    <p v-else class="price-caps">{{ priceAll5 }}</p>
                </template>
            </template>

            <div class="price-timer">倒计时 <span>{{ priceTimer }}</span></div>

            <span slot="footer" class="dialog-footer">
            <el-button @click="priceDialogShowComfirm = false">取 消</el-button>
            <el-button type="primary" @click="submitPrice">确 认</el-button>
        </span>

        </el-dialog>


        <!-- 返回按钮 -->
        <transition name="bounce">
            <el-button v-if="reviewStatus!=0" class="review-back" type="primary" @click="reviewStatus=0;toTop();" round>
                返回进度信息
            </el-button>
        </transition>


        <!-- 调试立项状态使用 -->
        <el-input-number v-show="stepTester" v-model="stepStatus" size="mini" :min="1" :max="10" label="描述文字" style="position:fixed;bottom:0;left:0;z-index:999;border:3px solid #f00;"></el-input-number>

        <Unpaid-dialog v-if="unpaidDialogVisible.isShow" :visible="unpaidDialogVisible" @update="init" :info="unpaidInfo"/>

    </div><!--container-center-->
</template>

<script>
    import UnpaidDialog from './UnpaidDialog'
    import banner from '@/assets/imgs/banner_inviteMng.png'
    import util from '@/util'
    import inviteRecon from './InviteRecon'
    import ChangePeTypeDialog from '@/pages/dsp/invite/components/ChangePeTypeDialog'
    import MutiPayDialog from '@/pages/dsp/invite/components/MutiPayDialog'

    export default {
        name: 'invite-mng-info',
        components: {
            'invite-recon': inviteRecon,
            UnpaidDialog,
            ChangePeTypeDialog,
            MutiPayDialog
        },
        data () {
            return {
                buttonFlag: true,
                reconButtonFlag: true,
                utilBaseUrl: util.baseUrl.replace(':8080', ''),

                stepTester: [false, true][0],
                uploadApi: `${util.baseUrl}rest/api/ftpRmq/rmqUpdate`,
                downloadApi: `${util.baseUrl}rest/file/down`,

                rules: {
                    noTax: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    taxRate: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    totalDays: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    changeType: [
                        {required: true, message: '必须选择'}
                    ]
                },

                // 洽谈通知数量
                negoNum: '',

                // 参数信息
                fid: decodeURIComponent(this.$route.params.fid),
                supplierId: this.$root.stockId,
                isStrategy: false,
                tabIndex: 0,

                // 基本信息
                infoData: {
                    finvitemethod: '',
                    segmentList: [{managers: []}]
                },
                // 报名信息
                finvitecontentArr: '',
                fqulificademandArr: '',
                signNoticeArr: '',
                cashDepositDesArr: '',
                hotTipArr: '',
                stepStatus: 0,
                reviewStatus: 0,

                // 项目经理信息
                managersDialogShow: false,
                managersSegList: [],
                managersActive: 'tab0',
                managersFulDialogShow: false,
                emptyManagers: false,
                managersFulList: [],
                managersForm: {manager: '', managers: [], set: false, add: false, segId: '', mgrId: ''},

                // 1 标段信息
                segmentActive: 'tab0',
                process: [],

                // 2 入围
                selectInfo: [],

                // 4 标书下载
                tenderList: [],
                tenderCanDown: false,

                // 5 踏勘及答疑
                reconQstTabelTabActive: 'tab01',
                reconReplyTabActive: 'fixed',
                isAnswerEnd: false,
                // 提疑
                reconQstForm: {
                    questionType: '0',
                    baseFileList: []
                },
                reconQstDialogShow: false,
                reconQstList: [],
                reconQstListShowed: [],  // 过滤无提疑类型
                reconQstDataDialogShow: false,
                reconQstListData: {baseFileList: []},
                // 踏勘表
                reconTableForm: {baseFileList: []},
                reconTableDialogShow: false,
                reconTableCheck: 0,
                reconTableList: [],
                // 答疑列表
                reconReplyListDialogShow: false,
                reconReplyList: [],
                reconReplyListCurr: {
                    answerContent: '',
                    baseFileList: []
                },

                // 6 回标
                bidCould: false,
                bidTabActive: 'tab01',
                bidDateEnd: false,
                bidTechDateEnd: false,
                bidBusBtnIsGrey: false,
                bidTechBtnIsGrey: false,
                oldtypeid: '',
                fwqCurrentTime: '',
                businessScore: '',
                payStatus:'',
                payStatusDialog: false,
                isTwoPay: '',
                pay1: '',
                pay2: '',
                // 商务
                inviteCompanyName: window.sessionStorage.getItem('inviteCompanyName'),
                bidBusiDialogShow: false,
                bidBusiDialogShow2: false,
                bidBusiForm: {
                    taxRate: '',
                    noTax: '',
                    totalDays: '',
                    priceRemark: '',
                    baseFileList: [],
                    changeType: null,
                    returnEntryList: [
                        {}
                    ]
                },
                bidBusiList: [],
                bidBusiDataDialogShow: false,
                bidBusiData: {baseFileList: []},
                draftId: '',
                isDraft: false,
                busiUUID: '',
                isStandard: false,

                // 技术
                bidTechDialogShow: false,
                bidTechForm: {
                    baseFileList: []
                },
                bidTechList: [],
                bidTechDataDialogShow: false,
                bidTechData: {baseFileList: []},

                // 7 询标
                inqTabActive: 'tab01',
                inqBidBusiList: [],
                inqBidTechList: [],
                inqBidDemoList: [],

                // 8 竞价
                priceResult: '',
                priceTimeout: true,
                newFlag: false,
                priceData: {},
                nowPrice: {},
                priceDialogShow: false,
                priceDialogShowComfirm: false,
                priceForm: {
                    notaxBusinessPrice: '',
                    tax: '',
                    taxBusinessPrice: '',
                    notaxBusinessPrice1: '',
                    tax1: '',
                    taxBusinessPrice1: ''
                },
                payMethod1Enable: true,
                payMethod2Enable: true,
                payMethod1Price: {},
                payMethod2Price: {},
                priceCacheForm: [],
                priceTimer: '00:00:00',
                priceTimeDiff: 0,

                urlFid: '', //
                iframeUrl: '',  // 用于iframe跳转链接
                showMsg: '',

                unpaidDialogVisible: {
                    isShow: false
                },
                unpaidInfo: {},
                techFailReson: null,
                threeReturnShow: false,
                rulesThree: {
                    payRate: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^([1-9][0-9]{0,1})$/, message: '必须为不大于100的正整数', trigger: 'blur'}
                    ],
                    priceFloatRate: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^(\-|\+)?([1-9][0-9]{0,1})$/, message: '必须为不大于100的正整数或者负整数', trigger: 'blur'}
                    ],
                    taxRate: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^([1-9][0-9]{0,1})$/, message: '必须为不大于100的正整数', trigger: 'blur'}
                    ],
                    noTax: [
                        {required: true, message: '必填'},
                        {validator: 'regexp', pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '必须为整数或小数（最多两位）', trigger: 'blur'}
                    ],
                    changeType: [
                        {required: true, message: '必须选择'}
                    ]
                },
                changeNameArray: [
                    '',
                    '履约保函转为履约保证金',
                    '履约保函格式调整',
                    '履约保证金转为履约保函',
                    '履约保证金：投标保证金转为履约保证金，差额另补',
                    '履约保证金：另全额缴纳履约保证金',
                    '履约保函'
                ],
                auditArray: [
                    '申请审批中',
                    '申请打回',
                    '申请不通过',
                    '申请通过'
                ],
                peInviteInfo: {},
                isNeedManage: '1'//0:无须项目经理、!0:需要项目经理
            }
        },

        methods: {
            mutiPaySubmit(formData) {
                const loading = this.$loading({
                    lock: true,
                    fullscreen: true,
                    background: 'rgba(255,255,255,0.5)'
                })

                var data = {
                    returnType: 0,
                    bidReturnType: 1,
                    supplierId: this.supplierId,
                    inviteProjectId: this.fid,
                    nviteProjectEntryId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                }

                this.draftId = ''

                Object.assign(
                    data,
                    formData
                )
                this.$http.post('rest/api/project/tender/create', data).then((res) => {
                    this.$refs['mutiPayDialog'].closeDilalog();

                    setTimeout(function () {
                        loading.close()
                    }, 1000)

                    if (res.data.result) {
                        this.$message({message: '商务标提交成功', type: 'success'})
                        setTimeout(function () {
                            location.reload()
                        }, 1000)
                        this.getBidBusiList()
                    } else {
                        if (res.data.message == '付款方式已发生变更，请重新核对后提交'){
                            // 付款方式
                            this.$alert(res.data.message, '', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.$http.post('rest/api/project/tender/getLastPayMethod', {
                                        inviteProjectId: this.fid
                                    }).then((res) => {
                                        if (res.data.result) {
                                            this.isTwoPay  = res.data.value.isTwoPay || '0';
                                            // this.isTwoPay  = "1";
                                            this.pay1 = res.data.value.pay1 || '';
                                            this.pay2 = res.data.value.pay2 || '';

                                            let bidBusiForm = {
                                                taxRate: data.taxRate,
                                                noTax: data.noTax,
                                                totalDays: data.totalDays,
                                                priceRemark: data.priceRemark,
                                                baseFileList: data.baseFileList,
                                                changeType: data.changeType,
                                                priceRatio: data.priceRatio,
                                                returnEntryList: []
                                            }
                                            this.$refs.mutiPayDialog.openDialog(bidBusiForm);
                                        }
                                    })
                                }
                            });

                        }else {
                            this.$message({message: '商务标提交失败: ' + res.data.message, type: 'error'});
                        }
                    }
                    // this.resetForm();
                })
            },
            // 动态获取url
            getUrl (isView) {
                // {
                //     "entryId": "标段主键id",
                //     "isView": "0: 修改的操作的 1：查看试图模式"
                // }
                this.$http.post('rest/api/project/tender/getListUrl', {
                    entryId: this.urlFid,
                    isView: isView
                }).then((res) => {
                    if (res.data.result) {
                        this.iframeUrl = res.data.value
                    }
                })
            },

            sendFanruan (msg) {
                var ifr = document.getElementById('iframeA').contentWindow
                ifr.postMessage(msg, '*')
            },
            draftBidBusi (li) {
                if (this.isStandard && (this.payStatus == '' || this.payStatus == null)){
                    this.$alert('报价尚未开启，请稍后进行标准清单填报!')
                    return
                }
                if (this.payStatus=='0'||this.payStatus=='2'){
                    this.$alert('此标准清单已有调整,请按照新模板填写!')
                    return;
                }
                this.bidBusiForm.totalDays = li.totalDays
                this.bidBusiForm.changeType = li.changeType
                this.bidBusiForm.baseFileList = li.baseFileList || []
                this.bidBusiForm.baseFileList.forEach(function (data, index) {
                    data.name = data.fileOldName
                })
                this.draftId = li.id
                this.isDraft = li.isDraft

                if (this.bidBusiList.length > 0 &&  this.bidBusiList[0].id == this.draftId) {
                    this.oldtypeid = (this.bidBusiList[1]) ? this.bidBusiList[1].id : ''
                } else {
                    this.oldtypeid = ''
                }

                this.bidBusiDialogShow = true
                this.getUrl(0)
                this.payStatusDialog = true
                this.getPayStatus()
            },

            // 项目经理操作
            opMgr (segId, mgrId) {  // 弹框
                this.managersForm.segId = segId
                this.managersForm.mgrId = mgrId

                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})

                this.$http.post('rest/api/projectManagers/deal/getUsefulList', {
                    supplierId: this.supplierId
                }).then((res) => {
                    loading.close()
                    if (res.data.result) {
                        this.managersFulList = res.data.value
                        this.managersFulDialogShow = true
                    }
                })
            },
            addMgr () {  // 增加
                if (this.managersForm.managers.length == 0) {
                    this.$message({message: '请选择项目经理', type: 'error'})
                    return
                }

                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})

                this.$http.post('rest/api/projectManagers/deal/add', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: this.managersForm.segId,
                    managerIds: this.managersForm.managers
                }).then((res) => {
                    if (res.data.result) {
                        this.$message({message: '添加成功', type: 'success'})
                        this.resetForm()
                        this.managersDialogShow = false
                        this.managersFulDialogShow = false
                        setTimeout(function () {
                            location.reload()
                        }, 1000)
                    } else {
                        this.$message({message: '添加失败：' + res.data.message, type: 'error'})
                    }
                })
            },
            delMgr (segId, mgrId) {  // 删除
                this.$confirm('您确定要删除此项目经理吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post('rest/api/projectManagers/deal/delete', {
                        supplierId: this.supplierId,
                        projectId: this.fid,
                        segmentId: segId,
                        managerIds: [mgrId]
                    }).then((res) => {
                        if (res.data.result) {
                            this.$message({message: '删除成功', type: 'success'})
                            this.resetForm()
                            this.managersDialogShow = false
                            this.managersFulDialogShow = false
                            setTimeout(function () {
                                location.reload()
                            }, 1000)
                        } else {
                            this.$message({message: '删除失败：' + res.data.message, type: 'error'})
                        }
                    })
                })
            },
            setMgr () {  // 更换
                if (!this.managersForm.manager) {
                    this.$message({message: '请选择项目经理', type: 'error'})
                    return
                }
                this.$http.post('rest/api/projectManagers/deal/replace', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: this.managersForm.segId,
                    deleteManagerId: this.managersForm.mgrId,
                    newManagerId: this.managersForm.manager
                }).then((res) => {
                    if (res.data.result) {
                        this.$message({message: '更换成功', type: 'success'})
                        this.resetForm()
                        this.managersDialogShow = false
                        this.managersFulDialogShow = false
                        setTimeout(function () {
                            location.reload()
                        }, 1000)
                    } else {
                        this.$message({message: '更换失败：' + res.data.message, type: 'error'})
                    }
                })
            },

            // 回到顶部
            toTop () {
                util.toTop()
            },

            // 获取洽谈数量
            getNegoNum () {
                this.$http.post('rest/api/discuss/getNewDiscussNumber', {
                    supplierId: this.supplierId,
                    projectId: this.fid
                }).then((res) => {
                    if (res.data.result) {
                        this.negoNum = res.data.value || 0
                    } else {
                        console.log('[ERR] 获取洽谈数量: ' + res.data.message)
                    }
                })
            },

            // 上传文件格式验证
            beforeUpload (file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError () {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },

            // 分标段进度信息点击切换
            tabClick: function (pa) {
                var _segmentId = ''

                if (pa) {  // 非战略、有标段的
                    this.tabIndex = pa.index  // 获取 tab index

                    var o = this.selectInfo[this.tabIndex] || {}  // 当前tab 信息对象

                    this.bidCould = o && o.couldBid == '1'  // 当前tab 是否可以回标

                    _segmentId = o.nviteProjectEntryId

                    this.urlFid = _segmentId
                }

                // 当前tab 获取标段进度
                this.$http.post('rest/api/invite/project/process', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: _segmentId
                }).then((res) => {
                    if (res.data.result) {
                        this.process = res.data.value.reverse()
                    } else {
                        this.$message({message: 'Error: 分 tab 进度信息', type: 'error'})
                    }
                })
                // 校验资质是否过期
                this.$http.post('rest/api/invite/project/checkQulityInProject', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: _segmentId
                }).then((res) => {
                    if (!res.data.result) {
                        this.$alert(`${res.data.message}`, {type: 'warning'})
                        this.buttonFlag = false
                        this.reconButtonFlag = false
                    } else {
                        if (this.selectInfo[this.tabIndex].bidStatus == '3' && !this.isAnswerEnd) {
                            this.$http.post('rest/api/invite/project/checkQuestionEndDateInProject', {
                                projectId: this.fid
                            }).then((res) => {
                                this.reconButtonFlag = res.data.result;
                            })
                        }
                        if (this.selectInfo[this.tabIndex].bidStatus == '5') {
                            this.$http.post('rest/api/invite/project/techFailInfo', {
                                supplierId: this.supplierId,
                                fid: this.fid,
                                entryId: _segmentId
                            }).then((res) => {
                                if (res.data.value.length > 0) {
                                    this.techFailReson = res.data.value[0].reson || '未填写原因'
                                    this.buttonFlag = false
                                } else {
                                    this.buttonFlag = true
                                }
                            })
                        }
                    }
                })
                // 商务标、技术标列表
                let that = this
                if ((that.infoData.threeSelfType != '1' && that.infoData.threeSelfType != '2') || ((that.infoData.threeSelfType == '1' || that.infoData.threeSelfType == '2') && that.businessScore == '2')) {
                    this.getBidBusiList(function () {
                        that.getBidTechList(function () {
                            if (!that.bidTechDateEnd) {
                                // 技术标回标时间内
                                if (that.bidTechList.length == 0) {
                                    // 未技术标回标
                                    if (!that.isStandard) {
                                        that.bidBusBtnIsGrey = true
                                    }
                                    that.bidTechBtnIsGrey = false
                                } else {
                                    // 已技术标回标，技术标回标截止时间之前，商务标回标截止时间之前
                                    if (!that.bidDateEnd) {
                                        that.bidBusBtnIsGrey = false
                                        that.bidTechBtnIsGrey = false
                                    }
                                }
                            } else {
                                // 过了技术标回标时间

                                if (!that.bidDateEnd) {
                                    // 商务标回标截止时间之前
                                    that.bidBusBtnIsGrey = false
                                    that.bidTechBtnIsGrey = true
                                }
                            }
                            if (that.bidDateEnd) {
                                // 过了商务标回标时间
                                that.bidBusBtnIsGrey = true
                                that.bidTechBtnIsGrey = true
                            }
                            if (that.businessScore == '3') {
                                that.bidBusBtnIsGrey = false
                            }
                        })
                    })
                } else {
                    this.getBidBusiList(function () {
                        if (that.bidDateEnd) {
                            // 过了商务标回标时间
                            that.bidBusBtnIsGrey = true
                        } else {
                            that.bidBusBtnIsGrey = false
                        }
                    })
                }

                // 询标三项
                this.getInqAll()

                // 8 竞价，战略招标没有竞价
                if (this.selectInfo[this.tabIndex].bidStatus == '4' && this.isAnswerEnd) {
                    this.$message({message: '当前踏勘答疑时间已过，您可以直接进行回标操作！', type: 'warning'})
                }

                if (this.selectInfo[this.tabIndex].bidStatus == '7' && !this.isStrategy) {
                    this.getPriceInfo()
                    this.runPriceInfoTimer()
                    this.fillCachePriceForm()
                }

                // 9 获取履约担保的数据 定标时
                if (this.selectInfo[this.tabIndex].bidStatus == '8' || this.selectInfo[this.tabIndex].bidStatus == '9') {
                    this.getChangeInfo()
                }

            },
            // 3 发标 更新至标书下载
            updateStatus: function () {
                if (this.tenderCanDown) {
                    const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                    this.$http.post('rest/api/invite/project/update/status?status=3', {
                        supplierId: this.supplierId,
                        projectId: this.fid
                    }).then((res) => {
                        if (res.data.result) {
                            var _this = this
                            setTimeout(function () {
                                _this.$message({message: '标书已经下载', type: 'success'})
                                setTimeout(function () {
                                    location.reload()
                                }, 2000)
                            }, 2000)
                        }
                    })
                }
            },

            // 5 踏勘及答疑 新增提疑
            addReconQst: function () {
                if (this.reconQstForm.questionType != 2) {
                    if (!this.reconQstForm.askTitle) {
                        this.$message({message: '请输入标题', type: 'error'})
                        return
                    }
                    if (!this.reconQstForm.questionType) {
                        this.$message({message: '请选择类型', type: 'error'})
                        return
                    }
                    if (!this.reconQstForm.askContent) {
                        this.$message({message: '请输入内容', type: 'error'})
                        return
                    }
                }

                var data = {
                    inviteProjectId: this.fid,
                    supplierId: this.supplierId
                }

                Object.assign(
                    data,
                    this.reconQstForm
                )

                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})

                this.$http.post('rest/api/project/question/create', {
                    bidQuestion: data
                }).then((res) => {
                    this.reconQstDialogShow = false
                    loading.close()

                    if (res.data.result) {
                        this.$message({message: '提交成功', type: 'success'})
                        setTimeout(function () {
                            location.reload()
                        }, 2000)
                        this.getReconQstList()
                    } else {
                        this.$message({message: res.data.message, type: 'error'})
                    }
                    this.resetForm()
                })
            },
            addReconQstHandle: function (response, file, fileList) {
                // if(file.status=='success'){
                this.reconQstForm.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },
            getReconQstList: function () {  // 获取提疑列表
                this.$http.post('rest/api/project/question/list', {
                    supplierId: this.supplierId,
                    projectId: this.fid
                }).then((res) => {
                    if (res.data.result) {
                        this.reconQstList = res.data.value || []
                        // 过滤无提疑类型
                        this.reconQstList.forEach((data, index) => {
                            if (data.questionType != 2) {
                                this.reconQstListShowed.push(data)
                            }
                        })
                    }
                })
            },
            showReconQstList: function (id) {
                this.reconQstDataDialogShow = true
                this.$http.post('rest/api/project/question/questionInfo?id=' + id).then((res) => {
                    if (res.data.result) {
                        this.reconQstListData = res.data.value
                    }
                })
            },
            // 5 踏勘及答疑 新增踏勘表
            addReconTable: function () {
                if (!this.reconTableCheck) {
                    this.$message({message: '请确认签章完成', type: 'error'})
                    return
                }

                var data = {
                    siteExploration: {
                        inviteProjectId: this.fid,
                        supplierId: this.supplierId
                    }
                }

                Object.assign(
                    data,
                    {baseFileList: this.reconTableForm.baseFileList}
                )

                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})

                this.$http.post('rest/api/project/question/createSite', data).then((res) => {
                    this.reconTableDialogShow = false
                    loading.close()

                    if (res.data.result) {
                        this.$message({message: '提交成功', type: 'success'})
                        setTimeout(function () {
                            location.reload()
                        }, 2000)
                        this.getReconTableList()
                    } else {
                        this.$message({message: res.data.message, type: 'error'})
                    }
                    this.resetForm()
                })
            },
            addReconTableHandle: function (response, file, fileList) {
                // if(file.status=='success'){
                this.reconTableForm.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },
            getReconTableList: function () {  // 获取踏勘列表
                this.$http.post('rest/api/project/question/list/site', {
                    supplierId: this.supplierId,
                    projectId: this.fid
                }).then((res) => {
                    if (res.data.result) {
                        this.reconTableList = res.data.value || []
                    }
                })
            },
            // 5 踏勘及答疑 答疑
            getReconReply: function () {
                this.$http.post('rest/api/project/question/answer/list', {
                    supplierId: this.supplierId,
                    projectId: this.fid
                }).then((res) => {
                    if (res.data.result) {
                        this.reconReplyList = res.data.value || []
                    }
                })
            },
            showReconReply: function (index) {
                this.reconReplyListDialogShow = true

                this.reconReplyListCurr = this.reconReplyList[index] || {answerContent: '', baseFileList: []}
            },

            // 6 回标 商务
            getUUID () {
                this.$http.post('rest/api/project/tender/getUuid', {
                    inviteProjectId: this.fid,
                    nviteProjectEntryId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                }).then((res) => {
                    this.busiUUID = res.data.message
                    console.log('[UUID] ' + this.busiUUID)
                })
            },
            getCurrentTime () {
                this.$http.get('rest/api/invite/project/getCurrentTimeLong').then((res) => {
                    this.fwqCurrentTime = res.data.value
                })
            },
            getPayStatus () {
                if (this.payStatusDialog) {
                    this.$http.post('rest/api/invite/project/pay', {
                    projectId: this.fid
                    }).then((res) => {
                        if (res.data.result) {
                            this.payStatus = res.data.value.payStatus;
                            if (res.data.value.payStatus != '0') {
                                setTimeout(() => {
                                    this.getPayStatus();
                                }, 1000 * 60 * 5)
                            } else {
                                this.$alert('当前标准清单已暂停，请提交已填报数据并关闭页面，稍后重新填报', '提示', {
                                    confirmButtonText: '已知悉',
                                    callback: action => {
                                        this.payStatusDialog = false;
                                    }
                                });
                            }
                        }
                    })
                }

            },
            addBidBusiShow () {
                if (this.bidDateEnd) {
                    this.$message({message: '商务标回标时间已截止', type: 'error'})
                    return
                }

                // 新增的时候不为草稿
                this.isDraft = false
                if (this.isStandard) {
                    if (this.payStatus == '' || this.payStatus == null){
                        this.$message({message: '报价尚未开启，请稍后进行标准清单填报', type: 'error'})
                        return
                    }
                    if (this.payStatus == '0') {
                        this.$message({message: '当前标准清单已暂停，请稍后进行填报', type: 'error'})
                        return
                    }
                    if (this.payStatus == '2') {
                        this.$message({message: '此标准清单已有调整，请按照新模板填写', type: 'error'})
                        return
                    }
                    if (this.bidBusiList.length > 0) {
                        // 如果是标准清单的情况下，有草稿不让发起，且打开草稿，需要保持uuid一致
                        if (this.bidBusiList[0].isDraft == '1') {
                            this.$message({type:'error', message: '标准清单回标存在草稿，请使用草稿！'})
                            return;
                        }
                        this.oldtypeid = this.bidBusiList[0].id
                    } else {
                        this.oldtypeid = ''
                    }
                    this.bidBusiDialogShow = true
                    this.payStatusDialog = true

                    this.getUUID()

                    this.getUrl(0)

                    this.getPayStatus()

                } else {
                    if (this.isTwoPay == '1'){
                        if (this.bidBusiList.length > 0) {
                            let bidBusiForm = {
                                taxRate: this.bidBusiList[0].taxRate,
                                noTax: this.bidBusiList[0].noTax,
                                totalDays: this.bidBusiList[0].totalDays,
                                priceRemark: this.bidBusiList[0].priceRemark,
                                baseFileList: this.bidBusiList[0].baseFileList,
                                changeType: this.bidBusiList[0].changeType,
                                priceRatio: this.bidBusiList[0].priceRatio,
                                returnEntryList: []
                            }
                            bidBusiForm.baseFileList.forEach(function (data, index) {
                                data.name = data.fileOldName
                            })
                            this.$refs.mutiPayDialog.openDialog(bidBusiForm);
                        }else {
                            this.$refs.mutiPayDialog.openDialog();
                        }

                        return;
                    }

                    // 提交的时候在最后一次提交记录上改
                    if (this.infoData.threeSelfType != '1') {
                        // 非三材类回标
                        if (this.bidBusiList.length > 0) {
                            this.bidBusiForm = {
                                taxRate: this.bidBusiList[0].taxRate,
                                noTax: this.bidBusiList[0].noTax,
                                totalDays: this.bidBusiList[0].totalDays,
                                priceRemark: this.bidBusiList[0].priceRemark,
                                baseFileList: this.bidBusiList[0].baseFileList,
                                changeType: this.bidBusiList[0].changeType,
                                returnEntryList: []
                            }
                            this.bidBusiForm.baseFileList.forEach(function (data, index) {
                                data.name = data.fileOldName
                            })
                        }
                        this.bidBusiDialogShow2 = true
                    } else {
                        // 三材料回标
                        if (this.bidBusiList.length > 0) {
                            this.bidBusiForm = {
                                priceRemark: this.bidBusiList[0].priceRemark,
                                baseFileList: this.bidBusiList[0].baseFileList,
                                changeType: this.bidBusiList[0].changeType,
                                returnEntryList: this.bidBusiList[0].returnEntryList
                            }
                            this.bidBusiForm.baseFileList.forEach(function (data, index) {
                                data.name = data.fileOldName
                            })
                        }
                        this.threeReturnShow = true
                    }
                }
            },
            deleteHb: function (id, type) {
                this.$confirm('您确定要删除该条记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                    this.$http.post('rest/api/project/tender/delete', {
                        'id': id
                    }).then((res) => {
                        loading.close()
                        if (res.data.result) {
                            this.$alert('删除成功!')
                            if (type == 'sw') {
                                this.getBidBusiList()
                            } else if (type == 'js') {
                                this.getBidTechList()
                            }
                        } else {
                            this.$message({message: res.data.message, type: 'error'})
                        }
                    })
                }).catch(() => {
                    this.$alert('已取消删除')
                })
            },
            addBidBusi: function (isDraft) {
                if (this.bidBusiForm.totalDays > 9999) {
                    this.$message({message: '总工期时间过长', type: 'error'})
                    return
                }

                var showedForm = this.isStandard ? 'bidBusiForm' : 'bidBusiForm2'

                this.$refs[showedForm].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            fullscreen: true,
                            background: 'rgba(255,255,255,0.5)'
                        })

                        if (this.isStandard) {
                            this.sendFanruan('_g().writeReport()')
                        }

                        var data = {
                            returnType: 0,
                            bidReturnType: 1,
                            supplierId: this.supplierId,
                            inviteProjectId: this.fid,
                            nviteProjectEntryId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                        }

                        if (this.isStandard) {
                            Object.assign(
                                data,
                                {
                                    id: this.draftId || this.busiUUID,
                                    isDraft: (isDraft ? 1 : 0)
                                }
                            )
                        }

                        this.draftId = ''

                        Object.assign(
                            data,
                            this.bidBusiForm,
                            {totalPrice: this.priceAll, totalPriceCapital: this.priceAllCaps}
                        )

                        this.$http.post('rest/api/project/tender/create', data).then((res) => {
                            this.bidBusiDialogShow = false
                            this.bidBusiDialogShow2 = false

                            setTimeout(function () {
                                loading.close()
                            }, 1000)

                            if (res.data.result) {
                                this.$message({message: res.data.message, type: 'success'})
                                setTimeout(function () {
                                    location.reload()
                                }, 1000)
                                this.getBidBusiList()
                            } else {
                                this.$message({message: '商务标提交失败: ' + res.data.message, type: 'error'})
                            }
                            // this.resetForm();
                        })
                    } else {
                        this.$message({message: '表单填写有误，请注意必填信息是否填写完整（报价、工期等）', type: 'error'})
                        return false
                    }
                })
            },
            addBidBusiHandle: function (response, file, fileList) {
                // if(file.status=='success'){
                this.bidBusiForm.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },
            getBidBusiList: function (fn) {
                this.$http.post('rest/api/project/tender/list', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId,
                    type: 0
                }).then((res) => {
                    if (res.data.result) {
                        this.bidBusiList = res.data.value
                        !!fn && fn()
                    }
                })
            },
            showBidBusiList: function (id) {
                this.getUrl(1)
                if(this.isTwoPay == '1'){
                    this.$http.post('rest/api/project/tender/info?id=' + id).then((res) => {
                        if (res.data.result) {
                            this.$refs['mutiPayDialog'].showDetail(res.data.value);
                        }
                    })
                }else {
                    this.bidBusiDataDialogShow = true
                    this.$http.post('rest/api/project/tender/info?id=' + id).then((res) => {
                        if (res.data.result) {
                            this.bidBusiData = res.data.value;
                        }
                    })
                }
            },
            // 6 回标 技术
            addBidTechShow () {
                if (this.bidTechDateEnd) {
                    this.$message({message: '技术标回标时间已截止', type: 'error'})
                    return
                }
                this.bidTechDialogShow = true
            },
            showBidTechList: function (id) {
                this.bidTechDataDialogShow = true
                this.$http.post('rest/api/project/tender/info?id=' + id).then((res) => {
                    if (res.data.result) {
                        this.bidTechData = res.data.value
                    }
                })
            },
            addBidTech: function () {
                var data = {
                    returnType: 1,
                    bidReturnType: 1,
                    supplierId: this.supplierId,
                    inviteProjectId: this.fid,
                    nviteProjectEntryId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                }

                if (this.bidTechForm.baseFileList.length == 0) {
                    this.$message({message: '请上传附件', type: 'error'})
                    return
                }

                Object.assign(
                    data,
                    this.bidTechForm
                )

                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})

                this.$http.post('rest/api/project/tender/create', data).then((res) => {
                    this.bidTechDialogShow = false
                    loading.close()

                    if (res.data.result) {
                        this.$message({message: '提交成功', type: 'success'})
                        setTimeout(function () {
                            location.reload()
                        }, 2000)
                        this.getBidTechList()
                    } else {
                        this.$message({message: res.data.message, type: 'error'})
                    }
                    this.resetForm()
                })
            },
            addBidTechHandle: function (response, file, fileList) {
                // if(file.status=='success'){
                this.bidTechForm.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },
            getBidTechList: function (fn) {
                this.$http.post('rest/api/project/tender/list', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId,
                    type: 1
                }).then((res) => {
                    if (res.data.result) {
                        this.bidTechList = res.data.value
                        !!fn && fn()
                    }
                })
            },
            // 7 询标
            getInqAll: function () {
                this.$http.get('rest/api/project/inquiry/list', {
                    params: {
                        supplierId: this.supplierId,
                        projectId: this.fid,
                        segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId,
                        type: 0
                    }
                }).then((res) => {
                    if (res.data.result) {
                        this.inqBidBusiList = res.data.value
                    }
                })
                this.$http.get('rest/api/project/inquiry/list', {
                    params: {
                        supplierId: this.supplierId,
                        projectId: this.fid,
                        segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId,
                        type: 1
                    }
                }).then((res) => {
                    if (res.data.result) {
                        this.inqBidTechList = res.data.value
                    }
                })
                this.$http.get('rest/api/project/inquiry/list', {
                    params: {
                        supplierId: this.supplierId,
                        projectId: this.fid,
                        segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId,
                        type: 2
                    }
                }).then((res) => {
                    if (res.data.result) {
                        this.inqBidDemoList = res.data.value
                    }
                })
            },
            checkPrice(price, res){
                if (price.payMethod == 1){
                    if (this.newFlag) {
                        // 除税价
                        if (res.data.value) {
                            let xbPrice = (res.data.value.noTax * 0.4)
                            console.log(xbPrice)
                            if (price.notaxBusinessPrice <= xbPrice) {
                                if (!this.hasShownMsg){
                                    this.$message({
                                        message: '贵司竞价下浮率超过40%，存在原投标报价虚高嫌疑，特予以警示。为保证价格（不限于各单价、合价）的合理性，请贵司今后避免出现类似情况。',
                                        type: 'warnning'
                                    })
                                }

                                this.hasShownMsg = true;
                            }
                        }
                    } else {
                        // 含税价
                        if (res.data.value) {
                            let xbPrice = (res.data.value.totalPrice * 0.4)
                            console.log(xbPrice)
                            if (price.taxBusinessPrice <= xbPrice) {
                                if (!this.hasShownMsg){
                                    this.$message({
                                        message: '贵司竞价下浮率超过40%，存在原投标报价虚高嫌疑，特予以警示。为保证价格（不限于各单价、合价）的合理性，请贵司今后避免出现类似情况。',
                                        type: 'warnning'
                                    })
                                }
                                this.hasShownMsg = true;
                            }
                        }
                    }
                }else {
                    let xbPrice = (res.data.value.totalPriceTwo * 0.4)
                    console.log(xbPrice)
                    if (price.taxBusinessPrice <= xbPrice) {
                        this.$message({
                            message: '贵司竞价下浮率超过40%，存在原投标报价虚高嫌疑，特予以警示。为保证价格（不限于各单价、合价）的合理性，请贵司今后避免出现类似情况。',
                            type: 'warnning'
                        })
                    }
                }
            },
            // 8 竞价
            getPriceInfo: function (ox) {
                this.$http.post('rest/api/business/priceInfo', {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                }).then((res) => {
                    if (res.data.result) {
                        this.priceData = res.data.value
                        this.priceData.businessStartDate = (this.priceData.businessStartDate || '').replace(/\-/g, '/')
                        this.priceData.currentTime = (this.priceData.currentTime || '').replace(/\-/g, '/')

                        // test
//                         this.priceData.businessStartDate = '2018/08/20 7:50:00'
//                         this.priceData.result = 0  // 0 报价中 1 淘汰 2 通过 3
//                         this.priceData.priceTime = 5
//                         this.priceData.currentTime = new Date().getTime()+(5 * 60 * 1000)//10分钟误差
                        this.newFlag = this.priceData.newFlag
                        this.priceResult = this.priceData.result
                        if(this.priceData.resultDhsBidBusinessPrice){
                            this.showMsg = this.priceData.resultDhsBidBusinessPrice.showMsg
                        }

                        if (this.isTwoPay == '1'){
                            for (let i = 0; i < this.priceData.businessPriceTwoList.length; i++) {
                                let list = this.priceData.businessPriceTwoList[i];
                                for (let j = 0; j < list.length; j++){
                                    let price = list[j];
                                    if (price.payMethod == 1){
                                        if (!price.isBoult) {
                                            this.payMethod1Price = price
                                        }
                                    }else {
                                        if (!price.isBoult) {
                                            this.payMethod2Price = price
                                        }
                                    }
                                }
                            }

                            let endPriceList = this.priceData.businessPriceTwoList[0];

                            if (endPriceList.length == 2){
                                this.payMethod1Enable = true;
                                this.payMethod2Enable = true;
                            }else {
                                let price = endPriceList[0];
                                if (price.payMethod == 1){
                                    if (!price.isBoult) {
                                        this.payMethod1Enable = true;
                                        this.payMethod2Enable = false;
                                    }
                                }else {
                                    if (!price.isBoult) {
                                        this.payMethod1Enable = false;
                                        this.payMethod2Enable = true;
                                    }
                                }
                            }


                            let endPricePay1 = endPriceList[0];
                            if (endPricePay1 && endPricePay1.isBoult == '4') {
                                this.$http.post('rest/api/project/tender/getLaseInfoId', {
                                    'supplierId': this.supplierId,
                                    'projectId': this.fid,
                                    'segmentId': this.selectInfo[this.tabIndex].nviteProjectEntryId,
                                    'type': '0'// 0商务标 1技术标 2投标封样
                                }).then((res) => {
                                    this.checkPrice(endPricePay1, res);
                                })
                            }
                            if (endPriceList.length > 1){
                                let endPricePay2 = endPriceList[1];
                                if (endPricePay2 && endPricePay2.isBoult == '4') {
                                    this.$http.post('rest/api/project/tender/getLaseInfoId', {
                                        'supplierId': this.supplierId,
                                        'projectId': this.fid,
                                        'segmentId': this.selectInfo[this.tabIndex].nviteProjectEntryId,
                                        'type': '0'// 0商务标 1技术标 2投标封样
                                    }).then((res) => {
                                        // 含税价
                                        if (res.data.value) {
                                            this.checkPrice(endPricePay2, res);
                                        }
                                    })
                                }
                            }

                        }else {
                            for (var tempPrice of this.priceData.businessPriceList) {
                                if (!tempPrice.isBoult) {
                                    this.nowPrice = tempPrice
                                }
                            }

                            let endPrice = this.priceData.businessPriceList[0]
                            if (endPrice && endPrice.isBoult == '4') {
                                this.$http.post('rest/api/project/tender/getLaseInfoId', {
                                    'supplierId': this.supplierId,
                                    'projectId': this.fid,
                                    'segmentId': this.selectInfo[this.tabIndex].nviteProjectEntryId,
                                    'type': '0'// 0商务标 1技术标 2投标封样
                                }).then((res) => {
                                    if (this.newFlag) {
                                        // 除税价
                                        if (res.data.value) {
                                            let xbPrice = (res.data.value.noTax * 0.4)
                                            console.log(xbPrice)
                                            if (endPrice.notaxBusinessPrice <= xbPrice) {
                                                this.$message({
                                                    message: '贵司竞价下浮率超过40%，存在原投标报价虚高嫌疑，特予以警示。为保证价格（不限于各单价、合价）的合理性，请贵司今后避免出现类似情况。',
                                                    type: 'warnning'
                                                })
                                            }
                                        }
                                    } else {
                                        // 含税价
                                        if (res.data.value) {
                                            let xbPrice = (res.data.value.totalPrice * 0.4)
                                            console.log(xbPrice)
                                            if (endPrice.taxBusinessPrice <= xbPrice) {
                                                this.$message({
                                                    message: '贵司竞价下浮率超过40%，存在原投标报价虚高嫌疑，特予以警示。为保证价格（不限于各单价、合价）的合理性，请贵司今后避免出现类似情况。',
                                                    type: 'warnning'
                                                })
                                            }
                                        }
                                    }
                                })
                            }
                        }

                        if (!this.priceResult || this.priceResult == 5) {
                            var endTime = new Date(this.priceData.businessStartDate).getTime() + (this.priceData.priceTime || 0) * 60 * 1000
                            var curTime = new Date(this.priceData.currentTime).getTime()
                            if (curTime < endTime) {
                                if (ox) {
                                    this.priceTimeDiff = curTime - new Date().getTime()
                                }
                                this.runPriceTimer()
                                this.priceTimeout = false
                            } else {
                                if (this.selectInfo[this.tabIndex].bidStatus == 7) {
                                    this.priceTimeout = true
                                    clearInterval(window['invitePriceInfoTimer'])
                                    this.runPriceInfoTimer()
                                }
                            }
                        }
                    }
                })
            },
            cachePriceForm: function () {
                this.priceCacheForm[this.tabIndex] = {
                    notaxBusinessPrice: this.priceForm.notaxBusinessPrice,
                    tax: this.priceForm.tax,
                    notaxBusinessPrice1: this.priceForm.notaxBusinessPrice1,
                    tax1: this.priceForm.tax1,
                }
            },
            fillCachePriceForm: function () {
                var cache = this.priceCacheForm[this.tabIndex]
                this.priceForm.notaxBusinessPrice = cache ? cache.notaxBusinessPrice : ''
                this.priceForm.tax = cache ? cache.tax : ''
                this.priceForm.notaxBusinessPrice1 = cache ? cache.notaxBusinessPrice1 : ''
                this.priceForm.tax1 = cache ? cache.tax1 : ''
            },
            checkPriceForm: function () {
                if (this.isTwoPay == '0' || this.payMethod1Enable){
                    if (!this.priceForm.notaxBusinessPrice || !this.priceForm.notaxBusinessPrice.match(/^[0-9]*$/)) {
                        this.$message({message: '除税价请输入一个整数', type: 'error'})
                        return
                    }
                    if (!this.priceForm.tax || !this.priceForm.tax.match(/^\d+(\.\d{1,2})?$/)) {
                        this.$message({message: '税率请输入一个最多两位小数的数字', type: 'error'})
                        return
                    }
                    if (this.priceForm.tax > 100) {
                        this.$message({message: '税率输入错误', type: 'error'})
                        return
                    }
                }


                if (this.isTwoPay == '1' && this.payMethod2Enable) {
                    if (!this.priceForm.notaxBusinessPrice1 || !this.priceForm.notaxBusinessPrice1.match(/^[0-9]*$/)) {
                        this.$message({message: '除税价请输入一个整数', type: 'error'})
                        return
                    }
                    if (!this.priceForm.tax1 || !this.priceForm.tax1.match(/^\d+(\.\d{1,2})?$/)) {
                        this.$message({message: '税率请输入一个最多两位小数的数字', type: 'error'})
                        return
                    }
                    if (this.priceForm.tax1 > 100) {
                        this.$message({message: '税率输入错误', type: 'error'})
                        return
                    }
                }

                this.priceDialogShow = true
            },
            submitPrice: function () {
                if (this.priceTimeout) {
                    this.$message({
                        message: '竞价时间已结束，竞价开始于 ' + this.priceData.businessStartDate + ', 竞价时长为 ' + this.priceData.priceTime + ' 分钟',
                        type: 'error'
                    })
                    return
                }

                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                // if (this.isTwoPay == '0'){
                if (this.isTwoPay == '1'){
                    let fids = this.priceData.fid.split(',');

                    let priceList = [];

                    if (fids.length == 2){
                        priceList = [
                            Object.assign(
                                {
                                    id: this.payMethod1Price.id,
                                    businessSetId: fids[0],
                                    supplierId: this.supplierId,
                                    projectId: this.fid,
                                    segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                                },
                                {
                                    notaxBusinessPrice: this.priceForm.notaxBusinessPrice,
                                    tax: this.priceForm.tax,
                                    taxBusinessPrice: this.priceAll2
                                }
                            ),
                            Object.assign(
                                {
                                    id: this.payMethod2Price.id,
                                    businessSetId: fids[1],
                                    supplierId: this.supplierId,
                                    projectId: this.fid,
                                    segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                                },
                                {
                                    notaxBusinessPrice: this.priceForm.notaxBusinessPrice1,
                                    tax: this.priceForm.tax1,
                                    taxBusinessPrice: this.priceAll4
                                }
                            )
                        ];
                    }else {
                        if (this.payMethod1Enable){
                            priceList = [
                                Object.assign(
                                    {
                                        id: this.payMethod1Price.id,
                                        businessSetId: fids[0],
                                        supplierId: this.supplierId,
                                        projectId: this.fid,
                                        segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                                    },
                                    {
                                        notaxBusinessPrice: this.priceForm.notaxBusinessPrice,
                                        tax: this.priceForm.tax,
                                        taxBusinessPrice: this.priceAll2
                                    }
                                )
                            ];
                        }else {
                            priceList = [
                                Object.assign(
                                    {
                                        id: this.payMethod2Price.id,
                                        businessSetId: fids[0],
                                        supplierId: this.supplierId,
                                        projectId: this.fid,
                                        segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                                    },
                                    {
                                        notaxBusinessPrice: this.priceForm.notaxBusinessPrice1,
                                        tax: this.priceForm.tax1,
                                        taxBusinessPrice: this.priceAll4
                                    }
                                )
                            ];
                        }

                    }


                    this.$http.post('rest/api/business/updatePriceInfoTwo',
                        priceList
                    ).then((res) => {
                        this.priceDialogShow = false
                        this.priceDialogShowComfirm = false
                        loading.close()
                        if (res.data.result) {
                            this.$message({message: '提交成功', type: 'success'})
                            setTimeout(function () {
                                location.reload()
                            }, 2000)
                            this.resetForm()
                        } else {
                            this.$message({message: res.data.message, type: 'error'})
                        }
                    })
                }else {
                    this.$http.post('rest/api/business/updatePriceInfo',
                        Object.assign(
                            {
                                id: this.nowPrice.id,
                                businessSetId: this.priceData.fid,
                                supplierId: this.supplierId,
                                projectId: this.fid,
                                segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                            },
                            {
                                notaxBusinessPrice: this.priceForm.notaxBusinessPrice,
                                tax: this.priceForm.tax,
                                taxBusinessPrice: this.priceAll2
                            }
                        )
                    ).then((res) => {
                        this.priceDialogShow = false
                        this.priceDialogShowComfirm = false
                        loading.close()
                        if (res.data.result) {
                            this.$message({message: '提交成功', type: 'success'})
                            setTimeout(function () {
                                location.reload()
                            }, 2000)
                            this.resetForm()
                        } else {
                            this.$message({message: res.data.message, type: 'error'})
                        }
                    })
                }

            },
            runPriceInfoTimer: function () {
                if (this.selectInfo[this.tabIndex].bidStatus != 7) {
                    return
                }
                clearInterval(window['invitePriceInfoTimer'])
                window['invitePriceInfoTimer'] = setInterval(() => {
                    this.getPriceInfo('getPriceTimeDiff')
                }, 3000)
            },
            runPriceTimer: function () {
                clearInterval(window['invitePriceTimer'])
                window['invitePriceTimer'] = setInterval(() => {
                    var secondsAll = Math.floor(
                        (new Date(this.priceData.businessStartDate).getTime() +
                            (this.priceData.priceTime || 0) * 60 * 1000 -
                            (new Date().getTime() + this.priceTimeDiff)
                        ) / 1000
                    )

                    if (secondsAll < 0) {
                        clearInterval(window['invitePriceTimer'])
                        return
                    }

                    var hh = Math.floor(secondsAll / 3600),
                        mm = Math.floor(secondsAll / 60) - hh * 60,
                        ss = secondsAll % 60

                    this.priceTimer = (hh > 9 ? hh : '0' + hh) + ':' + (mm > 9 ? mm : '0' + mm) + ':' + (ss > 9 ? ss : '0' + ss)
                }, 500)
            },

            // 上传控件移除集中处理
            handleRemoveReconQst: function (file, fileList) {
                this.reconQstForm.baseFileList = this.reconQstForm.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handleRemoveReconTable: function (file, fileList) {
                this.reconTableForm.baseFileList = this.reconTableForm.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handleRemoveBidBusi: function (file, fileList) {
                this.bidBusiForm.baseFileList = this.bidBusiForm.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handleRemoveBidTech: function (file, fileList) {
                this.bidTechForm.baseFileList = this.bidTechForm.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            // 关闭项目经理弹窗
            closeManagersDialog: function () {
                if (this.emptyManagers) {
                    this.$message({message: '每个标段至少添加一个项目经理', type: 'error'})
                    return
                }
                this.managersDialogShow = false
            },
            // 重置表单数据
            resetForm: function () {
                this.managersForm = {manager: '', managers: [], set: false, add: false, segId: '', mgrId: ''}

                this.reconQstForm = {baseFileList: []}

                this.reconTableForm = {baseFileList: []}
                this.reconTableCheck = 0

                this.bidBusiForm = {
                    taxRate: '',
                    noTax: '',
                    totalDays: '',
                    priceRemark: '',
                    baseFileList: [],
                    changeType: null,
                    returnEntryList: [
                        {}
                    ]
                }

                this.bidTechForm = {baseFileList: []}

                this.priceForm = {
                    notaxBusinessPrice: '',
                    tax: '',
                    taxBusinessPrice: '',
                    notaxBusinessPrice1: '',
                    tax1: '',
                    taxBusinessPrice1: ''
                }
            },

            showUnpaidDialog () {
                this.unpaidDialogVisible.isShow = true
                this.unpaidInfo = {
                    supplierId: this.supplierId,
                    projectId: this.fid,
                    segmentId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                }
            },
            init () {
                const loading = this.$loading({lock: true, background: 'rgba(255,255,255,0.5)'})
                // 获取项目数据
                this.$http.post('rest/api/invite/project/info', {
                    projectId: this.fid,
                    supplierId: this.supplierId
                }).then((res) => {
                    if (res.data.result) {
                        if (res.data.value == [] || res.data.value == null) {
                            this.$message({message: 'Error: invite/project/info 数据获取异常 ', type: 'error'})
                            return
                        }
                        this.infoData = res.data.value
                        let date1 = new Date(this.infoData.createDate);
                        let date2 = new Date("2022-03-31");
                        if(this.infoData.finvitemethod=='3STRATEGYINVITED' && date1.getTime()<date2.getTime()){
                            this.infoData.fphone = '*';
                        }
                        this.newFlag = this.infoData.isNew == 1;
                        this.finvitecontentArr = (this.infoData.finvitecontent || '').split('\n')
                        this.fqulificademandArr = (this.infoData.fqulificademand || '').split('\n')
                        this.signNoticeArr = (this.infoData.signNotice || '').split('\n')
                        this.cashDepositDesArr = (this.infoData.cashDepositDes || '').split('\n')
                        this.hotTipArr = (this.infoData.hotTip || '').split('\n')
                        this.isStrategy = (this.infoData.finvitemethod.charAt(0) == '3')
                        this.businessScore = this.infoData.evaluateMethod
                        this.isNeedManage = this.infoData.isNeedManage
                        this.payStatus = this.infoData.payStatus
                        this.$http.get('rest/api/invite/project/getCurrentTimeLong').then((res) => {
                            this.fwqCurrentTime = res.data.value
                            // 踏勘答疑是否截止

                            var now = this.fwqCurrentTime
                            console.log(this.infoData)
                            if (this.infoData.answerEndDate) {
                                let answerEndDateString = this.infoData.answerEndDate.replace(/-/g, '/')
                                var end = new Date(answerEndDateString).getTime()

                                if (now > end) {
                                    this.isAnswerEnd = true
                                }
                            }

                            // 商务标回标是否截止
                            if (this.infoData.fprtenderdate) {
                                var now = this.fwqCurrentTime
                                let fprtenderdateString = this.infoData.fprtenderdate.replace(/-/g, '/')
                                var end = new Date(fprtenderdateString).getTime()
                                if (now > end) {
                                    this.bidDateEnd = true
                                }
                            }

                            // 技术标回标是否截止
                            if (this.infoData.techTenderEndDate) {
                                var techNow = this.fwqCurrentTime
                                let techTenderEndDateString = this.infoData.techTenderEndDate.replace(/-/g, '/')
                                var techEnd = new Date(techTenderEndDateString).getTime()
                                if (techNow > techEnd) {
                                    this.bidTechDateEnd = true
                                }
                            }
                        })

                        // 是否是标准清单
                        this.isStandard = this.infoData.standardList == '1'

                        this.$root.navs.push({name: this.infoData.fname, path: ''})
                    }
                    // 有标段 项目经理信息
                    var arr = []
                    this.infoData.segmentList.forEach(data => {
                        if (data.hasSign) {
                            arr.push(data)
                        }
                    })
                    this.managersSegList = arr
                    // 战略招标没有标段，将项目模拟成标段
                    if (this.isStrategy) {
                        this.managersSegList = [{fid: '', fcurprojectname: this.infoData.fname, fbidnum: ''}]
                    }
                    console.log(this.isNeedManage,'inviteMngInfo')
                    this.managersSegList.forEach(data => {
                        this.$http.post('rest/api/invite/project/managers', {
                            supplierId: this.supplierId,
                            projectId: this.fid,
                            segmentId: data.fid
                        }).then((res) => {
                            if (res.data.result) {
                                data.managers = res.data.value
                                if (this.isNeedManage=='1' && data.managers.length == 0) {
                                    // 只要有标段没有项目经理就弹框
                                    this.managersDialogShow = true
                                    this.emptyManagers = true
                                }
                            }
                        })
                    })


                     // 付款方式
                    this.$http.post('rest/api/project/tender/getLastPayMethod', {
                        inviteProjectId: this.fid
                    }).then((res) => {
                        if (res.data.result) {
                            this.isTwoPay  = res.data.value.isTwoPay || '0';
                            // this.isTwoPay  = "1";
                            this.pay1 = res.data.value.pay1 || '';
                            this.pay2 = res.data.value.pay2 || '';
                        }
                    })

                    // 标书下载列表 & // 标书是否可以下载
                    this.$http.post('rest/api/invite/project/tender/list', {
                        projectId: this.fid
                    }).then((res) => {
                        if (res.data.result) {
                            this.tenderList = res.data.value
                        }
                    })
                    this.$http.post('rest/api/invite/project/tender/couldDownload', {
                        projectId: this.fid,
                        supplierId: this.supplierId
                    }).then((res) => {
                        if (res.data.result) {
                            var _res = res.data.value[0]
                            this.tenderCanDown = _res && _res.couldDownload && _res.couldDownload == '1'
                        }
                    })
                    // 获取入围信息
                    this.$http.post('rest/api/invite/project/select/info', {
                        supplierId: this.supplierId,
                        projectId: this.fid
                    }).then((res) => {
                        if (res.data.result) {
                            this.selectInfo = res.data.value

                            // 战略招标
                            if (this.infoData.finvitemethod.charAt(0) === '3') {
                                this.tabClick()
                            }

                            // 存在入围标段 继续获取更多信息
                            if (this.selectInfo.length > 0) {
                                this.tabClick({index: 0})
                            }
                        }

                        // 获取项目状态
                        this.$http.post('rest/api/invite/project/status', {
                            projectId: this.fid,
                            supplierId: this.supplierId
                        }).then((res) => {
                            loading.close()
                            if (res.data.result) {
                                this.stepStatus = res.data.value.status + 1

                                // 提疑、踏勘、答疑列表
                                this.getReconQstList()
                                this.getReconTableList()
                                this.getReconReply()

                                this.getNegoNum()
                                var bs = this.selectInfo[this.tabIndex]
                                // 战略招标没有竞价
                                if (bs && bs.bidStatus == '7' && !this.isStrategy) {
                                    this.getPriceInfo('getPriceTimeDiff')
                                    this.runPriceInfoTimer()
                                }
                            }
                        })
                    })
                })
            },
            addOrEditEntry (type) {
                if (type == 1) {
                    // 添加
                    if (this.bidBusiForm.returnEntryList.length > 1) {
                        this.$message({type: 'error', message: '付款比例最多只能添加两个'})
                        return
                    } else {
                        this.bidBusiForm.returnEntryList.push({})
                    }
                } else {
                    // 删除
                    if (this.bidBusiForm.returnEntryList.length == 1) {
                        this.$message({type: 'error', message: '付款比例最少保留一个'})
                        return
                    } else (
                        this.bidBusiForm.returnEntryList.splice(1, 1)
                    )
                }
            },
            submitThreeForm (isDraft) {

                this.$refs['threeForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            fullscreen: true,
                            background: 'rgba(255,255,255,0.5)'
                        })

                        var data = {
                            returnType: 0,
                            bidReturnType: 1,
                            supplierId: this.supplierId,
                            inviteProjectId: this.fid,
                            nviteProjectEntryId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                        }

                        this.draftId = ''

                        this.bidBusiForm.returnEntryList.forEach(temp => {
                            if (Number(temp.priceFloatRate) > 0) {
                                temp.priceFloatRate = '+' + Number(temp.priceFloatRate)
                            } else {
                                temp.priceFloatRate = '' + Number(temp.priceFloatRate)
                            }
                        })

                        Object.assign(
                            data,
                            this.bidBusiForm
                        )

                        this.$http.post('rest/api/project/tender/createThree', data).then((res) => {
                            this.bidBusiDialogShow = false
                            this.bidBusiDialogShow2 = false

                            setTimeout(function () {
                                loading.close()
                            }, 1000)

                            if (res.data.result) {
                                this.$message({message: '商务标提交成功', type: 'success'})
                                setTimeout(function () {
                                    location.reload()
                                }, 1000)
                                this.getBidBusiList()
                            } else {
                                this.$message({message: '商务标提交失败: ' + res.data.message, type: 'error'})
                            }
                            // this.resetForm();
                        })
                    } else {
                        this.$message({message: '表单填写有误，请注意必填信息是否填写完整', type: 'error'})
                        return false
                    }
                })
            },
            openPeDialog () {
                // 需要判断是否可以发起 只有第一条记录是 2 和 3才可以发起
                if (this.peInviteInfo.changeTypeRecords.length > 0 && '23'.indexOf(this.peInviteInfo.changeTypeRecords[0].approveStatus) ==  -1) {
                    this.$message({type: 'error', message: '您有未审批完成的提交记录，无法提交新的申请！'})
                    return
                }
                this.$refs.peDialog[this.tabIndex].openDialog()
            },
            openShowDialog (id) {
                this.$refs.peDialog[this.tabIndex].openShowDialog(id)
            },
            getChangeInfo () {
                this.$http.post('rest/api/dsp/peChange/getInvitePeChangeInfo', {
                    inviteProjectId: this.fid,
                    entryId: this.selectInfo[this.tabIndex].nviteProjectEntryId
                }).then((res) => {
                    if (res.data.result) {
                        this.peInviteInfo = res.data.value
                    }
                })
            },
            gotoTabVie (reStatus, tempStatus) {
                if (!tempStatus) {
                    if (reStatus != 1) {
                        this.$message({type: 'info', message: '请点击下方返回进度信息按钮返回!'})
                        return
                    }
                }
                if(tempStatus<this.stepStatus){
                    let checkStatus = Number(tempStatus) + 1
                    console.log(tempStatus,'tempStatus')
                    console.log(checkStatus,'checkStatus')
                    console.log(reStatus,'reStatus')
                    if (checkStatus != 4) {
                        if (checkStatus == reStatus) {
                            this.reviewStatus = 0
                        } else {
                            if (reStatus < checkStatus) {
                                this.reviewStatus = reStatus
                                if(reStatus == 8){
                                    this.getPriceInfo();
                                }
                            } else {
                                this.$message({type: 'info', message: '还未到此节点!'})
                            }
                        }
                    } else {
                        if (reStatus == 3) {
                            this.reviewStatus = 0
                        } else {
                            if (reStatus < 3) {
                                this.reviewStatus = reStatus
                            } else {
                                this.$message({type: 'info', message: '还未到此节点!'})
                            }
                        }
                    }
                }else{
                    console.log('进来2')
                    // 判断供应商是否可以报名（银行卡，投标承诺函）
                    this.$http.post('rest/api/invite/project/checkInviteProjectWork', {
                        supplierId: this.$root.stockId,
                        projectId:this.fid
                    }).then((res) => {
                        if(res.data.result){
                            let checkStatus = Number(tempStatus) + 1
                            if (checkStatus != 4) {
                                if (checkStatus == reStatus) {
                                    this.reviewStatus = 0
                                } else {
                                    if (reStatus < checkStatus) {
                                        this.reviewStatus = reStatus
                                    } else {
                                        this.$message({type: 'info', message: '还未到此节点!'})
                                    }
                                }
                            } else {
                                if (reStatus == 3) {
                                    this.reviewStatus = 0
                                } else {
                                    if (reStatus < 3) {
                                        this.reviewStatus = reStatus
                                    } else {
                                        this.$message({type: 'info', message: '还未到此节点!'})
                                    }
                                }
                            }
                        }else{
                            this.$alert(res.data.message)
                        }

                    });
                }
            }
        },
        created () {
            this.$root.navs = [{name: '招标管理', path: '/inviteMngList'}]
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'invite'
            this.$root.isPublic = false
        },
        updated () {
            // 战略招标时 隐藏 tabs 的 header
            if (this.infoData.finvitemethod.charAt(0) === '3') {
                var els = document.querySelectorAll('.el-tabs--border-card.canStrategy > .el-tabs__header')
                els.forEach(function (el, index) {
                    if (el) {
                        el.style.height = 0
                        el.style.overflow = 'hidden'
                    }
                })
            }
        },
        mounted: function () {
            window.ji = this

            // this.getCurrentTime();

            this.init()

            console.log(this.reviewStatus, this.stepStatus, 999)
        },
        computed: {
            // 商务标价格计算
            priceAll () {
                return this.bidBusiForm.noTax * (1000000 + parseInt(this.bidBusiForm.taxRate * 10000)) / 1000000
            },
            priceAllCaps () {
                return convertCurrency(this.priceAll)
            },
            // 竞价计算
            priceAll2 () {
                return this.priceForm.notaxBusinessPrice * (1000000 + parseInt(this.priceForm.tax * 10000)) / 1000000
            },
            // 含税价转换
            priceAll3 () {
                return convertCurrency(this.priceForm.notaxBusinessPrice * (1000000 + parseInt(this.priceForm.tax * 10000)) / 1000000)
            },
            // 竞价二计算
            priceAll4 () {
                return this.priceForm.notaxBusinessPrice1 * (1000000 + parseInt(this.priceForm.tax1 * 10000)) / 1000000
            },
            // 含税价转换
            priceAll5 () {
                return convertCurrency(this.priceForm.notaxBusinessPrice1 * (1000000 + parseInt(this.priceForm.tax1 * 10000)) / 1000000)
            },
            priceAllCaps2 () {
                return convertCurrency(this.priceForm.notaxBusinessPrice)
            },
            priceAllCaps4 () {
                return convertCurrency(this.priceForm.notaxBusinessPrice1)
            }

        }
    }

    function __getBaseFiles__ (file, fileList) {
        let fs = []
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0]
                item.bizTableName = f.bizTableName
                item.bizTablePkName = f.bizTablePkName
                item.bizTablePkValue = f.bizTablePkValue
                item.fid = f.fid
                item.fileCatagoryId = f.fileCatagoryId
                item.fileDesc = f.fileDesc
                item.fileOldName = f.fileOldName
                item.name = f.fileOldName
                item.fileName = f.fileName
                item.filePath = f.filePath
                item.fileSize = f.fileSize
                item.fileType = f.fileType
                item.sort = f.sort
            }
            fs.push(item)
        })
        console.log(fs)
        return fs
    }

    // 数字转中文人名币大写
    function convertCurrency (currencyDigits) {
// Constants:
        var MAXIMUM_NUMBER = 99999999999.99
        // Predefine the radix characters and currency symbols for output:
        var CN_ZERO = '零'
        var CN_ONE = '壹'
        var CN_TWO = '贰'
        var CN_THREE = '叁'
        var CN_FOUR = '肆'
        var CN_FIVE = '伍'
        var CN_SIX = '陆'
        var CN_SEVEN = '柒'
        var CN_EIGHT = '捌'
        var CN_NINE = '玖'
        var CN_TEN = '拾'
        var CN_HUNDRED = '佰'
        var CN_THOUSAND = '仟'
        var CN_TEN_THOUSAND = '万'
        var CN_HUNDRED_MILLION = '亿'
        var CN_SYMBOL = ''  // "人民币";
        var CN_DOLLAR = '元'
        var CN_TEN_CENT = '角'
        var CN_CENT = '分'
        var CN_INTEGER = '整'

// Variables:
        var integral    // Represent integral part of digit number.
        var decimal    // Represent decimal part of digit number.
        var outputCharacters    // The output result.
        var parts
        var digits, radices, bigRadices, decimals
        var zeroCount
        var i, p, d
        var quotient, modulus

// Validate input string:
        currencyDigits = currencyDigits.toString()
        if (currencyDigits == '') {
            // window.ji && ji.$message({message:"请输入小写金额！",type:'error'});
            return ''
        }
        if (currencyDigits.match(/[^,.\d]/) != null) {
            // window.ji && ji.$message({message:"小写金额含有无效字符！",type:'error'});
            return ''
        }
        if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
            // window.ji && ji.$message({message:"小写金额的格式不正确！",type:'error'});
            return ''
        }

// Normalize the format of input digits:
        currencyDigits = currencyDigits.replace(/,/g, '')    // Remove comma delimiters.
        currencyDigits = currencyDigits.replace(/^0+/, '')    // Trim zeros at the beginning.
        // Assert the number is not greater than the maximum number.
        if (Number(currencyDigits) > MAXIMUM_NUMBER) {
            // window.ji && ji.$message({message:"金额过大，应小于1000亿元！",type:'error'});
            return ''
        }

// Process the coversion from currency digits to characters:
        // Separate integral and decimal parts before processing coversion:
        parts = currencyDigits.split('.')
        if (parts.length > 1) {
            integral = parts[0]
            decimal = parts[1]
            // Cut down redundant decimal digits that are after the second.
            decimal = decimal.substr(0, 2)
        } else {
            integral = parts[0]
            decimal = ''
        }
        // Prepare the characters corresponding to the digits:
        digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE)
        radices = new Array('', CN_TEN, CN_HUNDRED, CN_THOUSAND)
        bigRadices = new Array('', CN_TEN_THOUSAND, CN_HUNDRED_MILLION)
        decimals = new Array(CN_TEN_CENT, CN_CENT)
        // Start processing:
        outputCharacters = ''
        // Process integral part if it is larger than 0:
        if (Number(integral) > 0) {
            zeroCount = 0
            for (i = 0; i < integral.length; i++) {
                p = integral.length - i - 1
                d = integral.substr(i, 1)
                quotient = p / 4
                modulus = p % 4
                if (d == '0') {
                    zeroCount++
                } else {
                    if (zeroCount > 0) {
                        outputCharacters += digits[0]
                    }
                    zeroCount = 0
                    outputCharacters += digits[Number(d)] + radices[modulus]
                }
                if (modulus == 0 && zeroCount < 4) {
                    outputCharacters += bigRadices[quotient]
                    zeroCount = 0
                }
            }
            outputCharacters += CN_DOLLAR
        }
        // Process decimal part if there is:
        if (decimal != '') {
            for (i = 0; i < decimal.length; i++) {
                d = decimal.substr(i, 1)
                if (d != '0') {
                    outputCharacters += digits[Number(d)] + decimals[i]
                }
            }
        }
        // Confirm and return the final output string:
        if (outputCharacters == '') {
            outputCharacters = CN_ZERO + CN_DOLLAR
        }
        if (decimal == '') {
            outputCharacters += CN_INTEGER
        }
        outputCharacters = CN_SYMBOL + outputCharacters
        return outputCharacters
    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    a {
        color: var(--cMain);
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    ul.invite-mng-list li {
        padding: 14px 12px;
        font-size: 14px;
        line-height: 28px;
    }

    ul.invite-mng-list li + li {
        border-top: 1px dashed #E5E6E5;
    }

    /*ul.invite-mng-list li:nth-child(odd) {background:#f8f8f8;}*/
    ul.invite-mng-list li a {
        color: var(--cTxt1);
        text-decoration: none;
    }

    ul.invite-mng-list li a:hover {
        color: var(--cMain);
    }

    .inviteInfo {
        font-size: 14px;
    }

    .inviteInfo.solid {
        height: 100px;
        border-bottom: 1px solid #E6E7E6;
        padding-top: 50px;
        position: relative;
    }

    .inviteInfo.solid > p {
        margin: 0 0 24px 0;
        color: #000;
        font-size: 14px;
        text-align: center;
    }

    .inviteInfo.solid > p.title {
        font-size: 18px;
        font-weight: bold;
    }

    .inviteInfo.solid > p.title.strategy::after {
        content: '战略';
        display: inline-block;
        width: 40px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-size: 12px;
        font-weight: normal;
        color: #fff;
        background: var(--cMint);
        border-radius: 2px;
        vertical-align: bottom;
        margin-left: 10px;
    }

    .inviteInfo.dashed {
        padding-bottom: 10px;
        border-bottom: 1px dashed #E6E7E6;
    }

    .inviteInfo.dashed.segment {
        margin-bottom: 20px;
    }

    .inviteInfo h5 {
        color: #252525;
        font-size: 15px;
        margin: 16px 0;
    }

    .inviteInfo h5::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: var(--cMain);
        vertical-align: middle;
        margin: 0 10px;
    }

    .inviteInfo .el-row {
        margin-bottom: 12px;
        word-break: break-all;
    }

    .inviteInfo .el-col-3,
    .inviteInfo .el-col-6 {
        color: #5f5f5f;
        text-align: right;
    }


    /* step */
    .invite-top-step {
        margin-bottom: 20px;
        padding-top: 20px;
        height: 80px;
        background: #f5f5f5;
    }

    .invite-btm-step {
        margin: 0;
        padding: 0;
        font-size: 14px;
    }

    .invite-btm-step a {
        color: var(--cMain);
    }

    .invite-btm-step li {
        width: 100%;
        list-style: none;
        float: left;
        height: 64px;
    }

    .invite-btm-step li:nth-child(even) {
        background: #F8F8F8;
    }

    .invite-btm-step div {
        float: left;
        height: 64px;
    }

    .invite-btm-step div span {
        margin-top: 20px;
    }

    .invite-btm-step div:nth-child(1) {
        width: 100px;
        padding: 0 40px;
        padding-top: 20px;
    }

    .invite-btm-step div:nth-child(2) {
        width: 100px;
        padding: 0 40px;
        padding-left: 20px;
    }

    .invite-btm-step div:nth-child(2)::before {
        content: '';
        position: absolute;
        display: block;
        width: 2px;
        height: 64px;
        background: #efefef;
        margin-left: -20px;
        z-index: 0;
    }

    .invite-btm-step div:nth-child(2) span {
        display: inline-block;
        color: #fff;
        background: #efefef;
        width: 60px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 10px;
    }

    .invite-btm-step div:nth-child(2) span.info {
        background: #8EB4E5;
    }

    .invite-btm-step div:nth-child(2) span.success {
        background: #9DC34C;
    }

    .invite-btm-step div:nth-child(3) {
        padding-top: 18px;
    }

    .invite-unit {
        display: inline-block;
        width: 49%;
        margin-top: 16px;
    }

    .btn-theme {
        width: 120px;
        margin: 50px 0;
    }

    .box-bordered {
        border: 1px solid #DCDFE6;
        padding: 10px 20px;
        margin-bottom: 20px;
    }

    .select-info {
        padding-left: 20px;
        font-size: 14px;
        color: var(--cTxt3);
        padding-bottom: 10px;
        border-bottom: 1px solid #efefef;
    }

    .select-info .el-col.el-col-2 {
        text-align: right;
    }

    .select-info .el-col.el-col-5 {
        color: var(--cTxt1);
    }

    .select-info b {
        color: var(--cTxt1);
    }

    .tabs-margin {
        margin: 20px 0 40px 0;
    }

    .reconTemplate {
        float: right;
        color: var(--cMain);
    }

    .review-back {
        position: fixed;
        bottom: 60px;
        left: 50%;
        margin-left: -100px;
        z-index: 9;
        box-shadow: 0 6px 30px rgba(242, 134, 25, .5);
        width: 200px;
        text-shadow: 0 2px 2px rgba(0, 0, 0, .1);
    }

    .btn-nego {
        position: relative;
    }

    .btn-nego span {
        position: absolute;
        display: block;
        background: #F45454;
        color: #fff;
        border-radius: 12px;
        margin-left: 52px;
        margin-top: -6px;
        padding: 2px 6px;
        font-size: 12px;
    }

    .btn-managers {
        position: absolute;
        margin-left: 1104px;
    }

    .btn-managers {
        position: absolute;
        margin-left: 1104px !important;
    }


    .price-box {
        border-top: 1px dashed #dcdddc;
        padding: 20px 0;
        text-align: center;
    }

    .price-box .price-left,
    .price-box .price-right {
        display: inline-block;
        width: 45%;
        padding: 20px 0;
        text-align: left;
        box-shadow: none;
        vertical-align: top;
        min-height: 300px;
    }

    .price-box .price-right {
        margin-left: 2%;
    }


    .price-box .price-left ul li + li {
        margin-top: 50px;
    }

    .price-box .price-left ul li + li:before {
        position: absolute;
        display: inline-block;
        content: '';
        width: 4px;
        height: 50px;
        background: #DFE3E7;
        margin-left: 7px;
        margin-top: -51px;
    }

    .price-box .price-left ul li label {
        padding-left: 30px;
        font-weight: bold;
    }

    .price-box .price-left ul li label:before {
        position: absolute;
        display: inline-block;
        content: '';
        width: 12px;
        height: 12px;
        border-radius: 12px;
        margin-left: -30px;
        margin-top: 3px;
        background: var(--cMain);
        border: 3px solid #FFECC5;
    }

    .price-box .price-left ul li span {
        color: var(--cMain);
        font-weight: bold;
        font-size: 18px;
    }

    .price-box .price-left ul li .mutiply-result span {
        font-size: 15px;
    }

    .price-box .price-left ul li i {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 4px;
        font-style: normal;
        font-size: 12px;
        color: #fff;
        background: var(--cMint);
    }

    .price-box .price-left ul li i.fail {
        background: var(--cFail);
    }

    .price-timer {
        text-align: center;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .price-timer span {
        color: var(--cMain);
    }

    .price-box .price-right .price-timer {
        font-size: 20px;
    }

    .price-right-tip {
        height: 240px;
        background: url('') no-repeat center;
    }

    .price-right-tip.success {
        background-image: url(data:image/png;base64,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);
    }

    .price-right-tip.fail {
        background-image: url(data:image/png;base64,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);
    }

    .price-right-tip.pass {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #F28718;
        line-height: 100px;
    }

    .price-right-tip.pass::before {
        content: '下一轮未开始，等待中..';
    }

    .price-right-tip.result {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #F28718;
        line-height: 100px;
    }

    .price-caps {
        color: var(--cMain);
        text-align: center;
        font-size: 26px;
        font-weight: bold;
    }

    .el-col {
        padding-bottom: 6px;
    }

    .el-alert.el-alert--error {
        margin-top: 12px;
    }

    /* 返回按钮动画 */
    .bounce-enter-active {
        animation: bounce-in .32s;
    }

    .bounce-leave-active {
        animation: bounce-in .32s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }

    .el-button-grey {
        background: #ccc;
        border: 1px solid #ccc;
    }

    .el-button-grey:hover {
        background: #ccc;
        border: 1px solid #ccc;
    }

    .option-btn-group {
        position: absolute;
        right: 0;
    }
    .tech-fail-div {
        border: solid 1px #E4E7ED;
        margin-top: 10px;
    }
    .tech-fail-div h4 {
        margin-block-start: 10px;
        margin-block-end: 5px;
        margin-inline-start: 10px;
        font-size: 14px;
    }
    .tech-fail-div div {
        margin: 10px 10px;
        font-size: 14px;
    }
    .pe_change_type .el-radio+.el-radio {
        margin-left: 0px;
    }
    .pe_change_type .el-radio {
        display: block;
        padding: 3px 0;
    }


    .table-box {
        margin-top: 30px;
        border: 1px solid #f5f5f5;
    }

    .table-box .table-head {
        background-color: #f5f5f5;
        padding: 0 10px;
        height: 35px;
        line-height: 35px;
        font-size: 12px;
    }

    .table-box .table-row {
        border-top: 1px solid #f5f5f5;
        padding: 0 10px;
        height: 45px;
        line-height: 45px;
        font-size: 12px;
    }

    .table-box .textLeft {
        text-align: left;
        padding-bottom: 0;
    }

    .table-box .textRight {
        text-align: right;
        padding-bottom: 0;
    }

    .status-color0 {
        color: blue;
    }
    .status-color1 {
        color: darkgrey;
    }
    .status-color2 {
        color: red;
    }
    .status-color3 {
        color: green;
    }

    .slot_step_icon {
        display: block;height: 30px;width: 30px;line-height: 30px;cursor: pointer;
    }

    .bid-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bid-wrap .title{
        font-size:14px;
        color:#333;
    }
    .dashed {
        margin-bottom: 20px;
        border-bottom: 1px dashed #E6E7E6;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteMngInfo.vue